<template>
  <div>
    <v-container grid-list-xl v-if="(canViewRefinery || canViewZimmet || canViewAtolye) && tenantId === 1">
      <section v-if="canViewRefinery" class="fin-card">
        <div class="fin-head fin-head--amber">
          <div class="fin-head-title">
            <span class="material-icons fin-head-icon" style="color:#92400e">factory</span>
            <h2 class="fin-title" style="color:#92400e">Rafineri Mutabakatı</h2>
          </div>
          <div class="fin-head-actions">
            <button class="fin-textbtn" style="color:#b45309" @click="openGiveGold">
              <span class="material-icons fin-btn-icon">send</span>Rafineriye Altın Ver
            </button>
            <button class="fin-textbtn" style="color:#b45309" @click="openIntakeHistory">
              <span class="material-icons fin-btn-icon">history</span>Geçmiş
            </button>
            <div class="fin-chip fin-chip--green">
              <span class="fin-chip-label">Sahip Olduğumuz Altın:</span>
              <span class="fin-chip-value">{{ formatGram(refineryReconciliation.totalOwnedPureGram) }}</span>
            </div>
          </div>
        </div>
        <div class="fin-split">
          <div class="fin-col">
            <h3 class="fin-subtitle" style="color:#dc2626">Parası Yatmamış Anlaşmalar</h3>
            <div class="fin-tablewrap">
              <table class="fin-table">
                <thead>
                  <tr>
                    <th>Tarih</th><th>Rafineri</th><th class="ta-r">Has Gram</th><th class="ta-r">Tutar</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p, i) in refineryReconciliation.unpaidAgreements" :key="'u'+i">
                    <td>{{ formatDateOnly(p.agreementDate) }}</td>
                    <td class="fw-500">{{ p.refineryName }}</td>
                    <td class="ta-r">{{ formatGram(p.pureGram) }}</td>
                    <td class="ta-r">{{ formatNumber(p.agreedAmount) }} ₺</td>
                  </tr>
                  <tr v-if="!refineryReconciliation.unpaidAgreements || refineryReconciliation.unpaidAgreements.length === 0">
                    <td colspan="4" class="fin-empty">Kayıt yok</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="fin-foot" style="color:#dc2626">
              <span class="fin-foot-label">Toplam Ödenecek:</span>
              <span class="fin-foot-value">{{ formatNumber(refineryReconciliation.totalUnpaidAmount) }} ₺</span>
            </div>
          </div>
          <div class="fin-col fin-col--divide">
            <h3 class="fin-subtitle" style="color:#059669">Rafineride Sahip Olduğumuz Altın</h3>
            <div class="fin-tablewrap">
              <table class="fin-table">
                <thead>
                  <tr>
                    <th>Rafineri</th><th class="ta-r">Dün</th><th class="ta-r">Bugün</th><th class="ta-c">Fark</th><th class="ta-r">Girdi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p, i) in refineryReconciliation.ownedGoldByRefinery" :key="'o'+i">
                    <td class="fw-500">{{ p.refineryName }}</td>
                    <td class="ta-r muted">{{ formatGram(p.yesterdayPureGram) }}</td>
                    <td class="ta-r fw-700">{{ formatGram(p.totalPureGram) }}</td>
                    <td class="ta-c text-no-wrap" :style="diffStyle(p.totalPureGram - p.yesterdayPureGram)">{{ formatDiff(p.totalPureGram - p.yesterdayPureGram) }}</td>
                    <td class="ta-r">
                      <button v-if="p.refineryId > 0" class="fin-linkbtn" style="color:#059669" @click="openIntake(p)">
                        <span class="material-icons fin-btn-icon">add_circle_outline</span>Girdi
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!refineryReconciliation.ownedGoldByRefinery || refineryReconciliation.ownedGoldByRefinery.length === 0">
                    <td colspan="5" class="fin-empty">Kayıt yok</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="fin-foot" style="color:#059669">
              <span class="fin-foot-label">Dün:</span>
              <span class="fin-foot-value" style="font-size:15px;font-weight:600">{{ formatGram(refineryReconciliation.totalYesterdayOwnedPureGram) }}</span>
              <span class="fin-foot-label" style="margin-left:12px">Bugün:</span>
              <span class="fin-foot-value">{{ formatGram(refineryReconciliation.totalOwnedPureGram) }}</span>
              <span class="text-no-wrap" :style="diffStyle(refineryReconciliation.totalOwnedPureGram - refineryReconciliation.totalYesterdayOwnedPureGram)" style="margin-left:10px;font-weight:700">{{ formatDiff(refineryReconciliation.totalOwnedPureGram - refineryReconciliation.totalYesterdayOwnedPureGram) }}</span>
            </div>
          </div>
        </div>
      </section>

      <v-dialog v-model="intakeDialog" :max-width="intakeForm.kind === 1 ? '880px' : '520px'" persistent>
        <v-card v-if="intakeRefinery">
          <div class="fin-modal-head fin-modal-head--amber">
            <span class="material-icons fin-head-icon" style="color:#92400e;font-size:24px">add_circle_outline</span>
            <h2 class="fin-title" style="color:#92400e">Girdi Bildirimi — {{ intakeRefinery.refineryName }}</h2>
          </div>

          <v-card-text class="pt-4">
            <div class="caption grey--text mb-3">
              Bu rafinerideki mevcut bakiye: <strong>{{ formatGram(intakeRefinery.totalPureGram) }}</strong>
            </div>

            <template v-if="intakeStep === 1">
              <div class="subtitle-2 mb-2">Ne aldınız?</div>
              <v-radio-group v-model="intakeForm.kind" row class="mt-0">
                <v-radio label="Saf Altın" :value="0"></v-radio>
                <v-radio label="Ürün" :value="1"></v-radio>
                <v-radio label="Atölye" :value="2"></v-radio>
              </v-radio-group>
              <v-select v-if="intakeForm.kind === 2" v-model="intakeForm.atolyeId" :items="atolyeler" item-text="name" item-value="id" label="Atölye" dense
                no-data-text="Atölye tanımlı değil (Admin > Atölyeler)"></v-select>
              <v-text-field v-if="intakeForm.kind !== 1" v-model.number="intakeForm.grams" label="Kaç gram?" type="number" min="0" step="0.0001" autofocus></v-text-field>

              <template v-if="intakeForm.kind === 1">
                <div class="caption grey--text mb-1">Tip seçin, ürünlerden adet girin. Girdikleriniz aşağıda "Seçilenler" listesinde toplanır. (Envanteri etkilemez, yalnızca kayıt.)</div>
                <v-btn-toggle v-model="intakeSelectedType" mandatory class="mb-2 fin-typetoggle">
                  <v-btn flat small :value="0">Takı</v-btn>
                  <v-btn flat small :value="1">Ziynet</v-btn>
                  <v-btn flat small :value="2">Külçe</v-btn>
                  <v-btn flat small :value="3">Diğer</v-btn>
                </v-btn-toggle>

                <div class="fin-tablewrap fin-scroll">
                  <table class="fin-table fin-table--compact">
                    <thead>
                      <tr><th>Ürün</th><th class="ta-c">Tip</th><th class="ta-r">Boşta</th><th class="ta-c">Birim Has</th><th class="ta-c">Adet</th></tr>
                    </thead>
                    <tbody>
                      <tr v-for="pr in intakeVisibleRows" :key="'ipv'+pr.rowKey">
                        <td class="fw-500">{{ pr.productName }}</td>
                        <td class="ta-c">{{ pr.inventoryTypeName }}</td>
                        <td class="ta-r">{{ pr.available }}</td>
                        <td class="ta-c" style="width:110px">
                          <v-text-field v-model.number="pr.hasPerUnit" type="number" min="0" step="0.0001" dense hide-details single-line style="width:100px"></v-text-field>
                        </td>
                        <td class="ta-c" style="width:90px">
                          <v-text-field v-model.number="pr.qty" type="number" min="0" dense hide-details single-line style="width:70px"></v-text-field>
                        </td>
                      </tr>
                      <tr v-if="intakeVisibleRows.length === 0"><td colspan="5" class="fin-empty">Seçili tipte ürün yok</td></tr>
                    </tbody>
                  </table>
                </div>

                <div class="subtitle-2 mt-3 mb-1" style="color:#92400e">Seçilen Ürünler ({{ intakeSelectedItems.length }})</div>
                <div class="fin-tablewrap fin-scroll">
                  <table class="fin-table fin-table--compact">
                    <thead>
                      <tr><th>Ürün</th><th class="ta-c">Tip</th><th class="ta-r">Birim Has</th><th class="ta-c">Adet</th><th class="ta-r">Satır Toplam</th><th></th></tr>
                    </thead>
                    <tbody>
                      <tr v-for="pr in intakeSelectedItems" :key="'ips'+pr.rowKey">
                        <td class="fw-500">{{ pr.productName }}</td>
                        <td class="ta-c">{{ pr.inventoryTypeName }}</td>
                        <td class="ta-r">{{ formatGram(pr.hasPerUnit) }}</td>
                        <td class="ta-c">{{ pr.qty }}</td>
                        <td class="ta-r fw-600">{{ formatGram((Number(pr.qty) || 0) * (Number(pr.hasPerUnit) || 0)) }}</td>
                        <td class="ta-c"><v-btn icon small color="red" @click="pr.qty = 0"><v-icon small>close</v-icon></v-btn></td>
                      </tr>
                      <tr v-if="intakeSelectedItems.length === 0"><td colspan="6" class="fin-empty">Henüz ürün seçilmedi</td></tr>
                    </tbody>
                  </table>
                </div>
                <div class="text-xs-right mt-2 subtitle-2" style="color:#92400e">Toplam Has Gram: {{ formatGram(intakeProductTotalGram) }}</div>
              </template>

              <v-text-field v-model="intakeForm.paymentBarcode" label="İşlem Barkodu (opsiyonel)"></v-text-field>
              <v-textarea v-if="intakeForm.kind === 2" v-model="intakeForm.notes" label="Not (atölyeden bu altın karşılığı talep edilen ürünler)" rows="2" auto-grow></v-textarea>
            </template>

            <template v-else-if="intakeStep === 2">
              <v-alert type="warning" dense text class="mb-2">Bu girdiyi onaylıyor musunuz? İşlem geri alınamaz.</v-alert>
              <div class="body-2"><strong>Tür:</strong> {{ intakeForm.kind === 0 ? 'Saf Altın' : (intakeForm.kind === 2 ? 'Atölye' : 'Ürün') }}</div>
              <div class="body-2" v-if="intakeForm.kind === 2"><strong>Atölye:</strong> {{ intakeAtolyeName }}</div>
              <div class="body-2"><strong>Gram:</strong> {{ formatGram(intakeEffectiveGram) }}</div>
              <div class="body-2" v-if="intakeForm.kind === 1">Ürün sayısı: {{ intakeProductRows.filter(r => Number(r.qty) > 0).length }} · Envanter etkilenmez</div>
              <div class="body-2" v-if="intakeForm.paymentBarcode"><strong>İşlem Barkodu:</strong> {{ intakeForm.paymentBarcode }}</div>
              <v-divider class="my-2"></v-divider>
              <div class="body-2">Rafineri bakiyesi: {{ formatGram(intakeRefinery.totalPureGram) }} → <strong>{{ formatGram(intakeRefinery.totalPureGram - intakeEffectiveGram) }}</strong></div>
              <div class="body-2 green--text text--darken-2" v-if="intakeForm.kind === 0">Saf altın envanterine eklenecek: +{{ formatGram(intakeForm.grams) }}</div>
              <div class="body-2 deep-purple--text text--darken-2" v-if="intakeForm.kind === 2">{{ intakeAtolyeName }} atölyesine eklenecek: +{{ formatGram(intakeForm.grams) }}</div>
            </template>

            <template v-else-if="intakeStep === 3 && intakeResult">
              <v-alert type="success" dense text class="mb-2">{{ intakeResult.message }}</v-alert>
              <div class="body-2">Rafineri: {{ formatGram(intakeResult.refineryOwnedBefore) }} → <strong>{{ formatGram(intakeResult.refineryOwnedAfter) }}</strong></div>
              <div class="body-2 green--text text--darken-2" v-if="intakeResult.inventoryPureGoldAfter != null">
                Saf Altın Envanteri: {{ formatGram(intakeResult.inventoryPureGoldBefore) }} → <strong>{{ formatGram(intakeResult.inventoryPureGoldAfter) }}</strong>
              </div>
            </template>
          </v-card-text>

          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <template v-if="intakeStep === 1">
              <v-btn flat @click="intakeDialog = false">Vazgeç</v-btn>
              <v-btn color="green darken-2" dark depressed :disabled="!intakeValid" @click="intakeStep = 2">Devam</v-btn>
            </template>
            <template v-else-if="intakeStep === 2">
              <v-btn flat :disabled="intakeBusy" @click="intakeStep = 1">Geri</v-btn>
              <v-btn color="green darken-2" dark depressed :loading="intakeBusy" @click="confirmIntake">Onayla</v-btn>
            </template>
            <template v-else>
              <v-btn color="primary" depressed @click="finishIntake">Kapat</v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="intakeHistoryDialog" max-width="1000px">
        <v-card>
          <div class="fin-modal-head fin-modal-head--amber">
            <span class="material-icons fin-head-icon" style="color:#92400e;font-size:24px">history</span>
            <h2 class="fin-title" style="color:#92400e">Rafineri Geçmişi</h2>
            <button class="fin-modal-close" @click="intakeHistoryDialog = false"><span class="material-icons" style="color:#92400e">close</span></button>
          </div>
          <v-layout wrap align-center class="px-3 pt-3">
            <v-flex xs12 sm3 class="px-1">
              <v-select v-model="intakeHistoryFilter.refineryId" :items="intakeRefineryOptions" item-text="name" item-value="id"
                label="Rafineri (boş = tümü)" clearable dense hide-details @change="loadIntakeHistory"></v-select>
            </v-flex>
            <v-flex xs6 sm2 class="px-1">
              <v-select v-model="intakeHistoryFilter.direction" :items="directionOptions" item-text="text" item-value="value"
                label="Yön (boş = tümü)" clearable dense hide-details @change="intakeExpanded = []"></v-select>
            </v-flex>
            <v-flex xs6 sm2 class="px-1">
              <v-menu v-model="intakeStartMenu" :close-on-content-click="false" max-width="290">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="intakeHistoryFilter.startDate" label="Başlangıç" readonly dense hide-details v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="intakeHistoryFilter.startDate" @input="intakeStartMenu = false; loadIntakeHistory()"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 sm2 class="px-1">
              <v-menu v-model="intakeEndMenu" :close-on-content-click="false" max-width="290">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="intakeHistoryFilter.endDate" label="Bitiş" readonly dense hide-details v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="intakeHistoryFilter.endDate" @input="intakeEndMenu = false; loadIntakeHistory()"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 sm3 class="px-1">
              <v-text-field v-model="intakeHistoryFilter.barcode" label="Barkod ara" clearable dense hide-details
                @input="onIntakeBarcodeSearch" prepend-inner-icon="search"></v-text-field>
            </v-flex>
          </v-layout>
          <v-card-text class="pa-3">
            <div class="fin-tablewrap">
              <table class="fin-table">
                <thead>
                  <tr>
                    <th style="width:36px"></th>
                    <th>Tarih</th><th>Rafineri</th><th class="ta-c">Yön</th><th class="ta-c">Tür</th><th class="ta-r">Gram</th>
                    <th>İşlem Barkodu</th><th class="ta-c">Rafineri (vardı → oldu)</th><th class="ta-c">Saf Altın Env.</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(p, i) in filteredIntakeHistory">
                    <tr :key="'ih'+i" :class="{ 'fin-row-clickable': p.items && p.items.length }" @click="p.items && p.items.length ? toggleIntakeRow(i) : null">
                      <td class="ta-c">
                        <span v-if="p.items && p.items.length" class="material-icons fin-expand-icon" style="color:#b45309">{{ intakeExpanded.indexOf(i) >= 0 ? 'expand_more' : 'chevron_right' }}</span>
                      </td>
                      <td>{{ formatDateOnly(p.createdDate) }}</td>
                      <td class="fw-500">{{ p.refineryName }}</td>
                      <td class="ta-c"><span class="fin-pill" :class="p.direction === 1 ? 'fin-pill--green' : 'fin-pill--amber'">{{ p.directionText }}</span></td>
                      <td class="ta-c">{{ p.kindText }}{{ p.atolyeName ? ' · ' + p.atolyeName : '' }}</td>
                      <td class="ta-r fw-500">{{ p.direction === 1 ? '+' : '−' }}{{ formatGram(p.grams) }}</td>
                      <td>{{ p.paymentBarcode || '-' }}</td>
                      <td class="ta-c text-no-wrap">{{ p.refineryOwnedBefore == null ? '-' : formatGram(p.refineryOwnedBefore) }} → {{ p.refineryOwnedAfter == null ? '-' : formatGram(p.refineryOwnedAfter) }}</td>
                      <td class="ta-c text-no-wrap">{{ p.inventoryPureGoldAfter == null ? '-' : (formatGram(p.inventoryPureGoldBefore) + ' → ' + formatGram(p.inventoryPureGoldAfter)) }}</td>
                    </tr>
                    <tr v-if="p.items && p.items.length && intakeExpanded.indexOf(i) >= 0" :key="'ihd'+i" class="fin-detail-row fin-detail-row--amber">
                      <td></td>
                      <td colspan="8">
                        <div class="fin-detail-title" style="color:#b45309">{{ p.direction === 1 ? 'Gönderilen Ürünler' : 'Girilen Ürünler' }}</div>
                        <table class="fin-subtable fin-subtable--amber">
                          <thead>
                            <tr><th>Ürün</th><th class="ta-c">Adet</th><th class="ta-r">Birim Has</th><th class="ta-r">Toplam Has</th></tr>
                          </thead>
                          <tbody>
                            <tr v-for="(it, j) in p.items" :key="'ihi'+i+'-'+j">
                              <td>{{ it.productName }}</td>
                              <td class="ta-c">{{ it.quantity }}</td>
                              <td class="ta-r">{{ formatGram(it.hasPerUnit) }}</td>
                              <td class="ta-r fw-600">{{ formatGram(it.hasGram) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </template>
                  <tr v-if="!filteredIntakeHistory || filteredIntakeHistory.length === 0">
                    <td colspan="9" class="fin-empty">{{ intakeHistoryLoading ? 'Yükleniyor...' : 'Kayıt yok' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
          <v-card-actions class="pa-3"><v-spacer></v-spacer><v-btn flat @click="intakeHistoryDialog = false">Kapat</v-btn></v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="giveGoldDialog" max-width="640px" persistent>
        <v-card>
          <div class="fin-modal-head fin-modal-head--amber">
            <span class="material-icons fin-head-icon" style="color:#92400e;font-size:24px">send</span>
            <h2 class="fin-title" style="color:#92400e">Rafineriye Altın Ver</h2>
          </div>
          <v-card-text class="pt-4">
            <template v-if="giveGoldStep === 1">
              <v-select v-model="giveGoldForm.refineryId" :items="giveRefineryOptions" item-text="name" item-value="id" label="Rafineri" dense></v-select>
              <div class="subtitle-2 mt-2 mb-1">Ne vereceksiniz?</div>
              <v-radio-group v-model="giveGoldForm.kind" row class="mt-0">
                <v-radio label="Saf Altın" :value="0"></v-radio>
                <v-radio label="Ürün" :value="1"></v-radio>
              </v-radio-group>

              <template v-if="giveGoldForm.kind === 0">
                <div class="fin-pure-note" :class="{ 'fin-pure-note--err': (Number(giveGoldForm.grams) || 0) > pureGoldAvailable }">
                  <span class="material-icons" style="font-size:18px">savings</span>
                  Sistemdeki saf altın: <strong>{{ formatGram(pureGoldAvailable) }}</strong>
                </div>
                <v-text-field v-model.number="giveGoldForm.grams" label="Gram" type="number" min="0" :max="pureGoldAvailable" step="0.0001"></v-text-field>
              </template>

              <template v-if="giveGoldForm.kind === 1">
                <div class="caption grey--text mb-1">Envanterden ürün seçip adet giriniz:</div>
                <div class="fin-tablewrap">
                  <table class="fin-table">
                    <thead>
                      <tr><th>Ürün</th><th class="ta-c">Tip</th><th class="ta-r">Boşta</th><th class="ta-r">Birim Has</th><th class="ta-c">Adet</th></tr>
                    </thead>
                    <tbody>
                      <tr v-for="(pr, i) in giveProductRows" :key="'gp'+i">
                        <td class="fw-500">{{ pr.productName }}</td>
                        <td class="ta-c">{{ pr.inventoryTypeName }}</td>
                        <td class="ta-r">{{ pr.available }}</td>
                        <td class="ta-r">{{ formatGram(pr.hasPerUnit) }}</td>
                        <td class="ta-c" style="width:90px">
                          <v-text-field v-model.number="pr.qty" type="number" min="0" :max="pr.available" dense hide-details single-line style="width:70px"></v-text-field>
                        </td>
                      </tr>
                      <tr v-if="!giveProductRows || giveProductRows.length === 0"><td colspan="5" class="fin-empty">Gönderilebilir ürün yok</td></tr>
                    </tbody>
                  </table>
                </div>
                <div class="text-xs-right mt-2 subtitle-2" style="color:#92400e">Hesaplanan: {{ formatGram(giveProductTotalGram) }}</div>
              </template>

              <v-text-field v-model="giveGoldForm.paymentBarcode" label="İşlem Barkodu (opsiyonel)"></v-text-field>
              <v-textarea v-model="giveGoldForm.notes" label="Not (opsiyonel)" rows="2" auto-grow></v-textarea>
            </template>

            <template v-else-if="giveGoldStep === 2">
              <v-alert type="warning" dense text class="mb-2">Bu gönderimi onaylıyor musunuz?</v-alert>
              <div class="body-2"><strong>Rafineri:</strong> {{ giveGoldRefineryName }}</div>
              <div class="body-2"><strong>Tür:</strong> {{ giveGoldForm.kind === 0 ? 'Saf Altın' : 'Ürün' }}</div>
              <div class="body-2"><strong>Verilen:</strong> {{ formatGram(giveGoldEffectiveGram) }}</div>
              <div class="body-2 green--text text--darken-2">Rafineri bakiyesi artacak: +{{ formatGram(giveGoldEffectiveGram) }}</div>
            </template>

            <template v-else-if="giveGoldStep === 3 && giveGoldResult">
              <v-alert type="success" dense text class="mb-2">{{ giveGoldResult.message }}</v-alert>
              <div class="body-2">Rafineri bakiyesi: {{ formatGram(giveGoldResult.refineryOwnedBefore) }} → <strong>{{ formatGram(giveGoldResult.refineryOwnedAfter) }}</strong></div>
            </template>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <template v-if="giveGoldStep === 1">
              <v-btn flat @click="giveGoldDialog = false">Vazgeç</v-btn>
              <v-btn color="amber darken-3" dark depressed :disabled="!giveGoldValid" @click="giveGoldStep = 2">Devam</v-btn>
            </template>
            <template v-else-if="giveGoldStep === 2">
              <v-btn flat :disabled="giveGoldBusy" @click="giveGoldStep = 1">Geri</v-btn>
              <v-btn color="amber darken-3" dark depressed :loading="giveGoldBusy" @click="confirmGiveGold">Onayla</v-btn>
            </template>
            <template v-else>
              <v-btn color="primary" depressed @click="finishGiveGold">Kapat</v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <section v-if="canViewZimmet" class="fin-card">
        <div class="fin-head fin-head--grey">
          <div class="fin-head-title">
            <span class="material-icons fin-head-icon" style="color:#565e74;font-size:24px">assignment_ind</span>
            <h2 class="fin-title" style="color:#0f172a">Zimmet Tablosu</h2>
          </div>
          <div class="fin-head-actions">
            <button class="fin-textbtn" style="color:#565e74" @click="openMainVault">
              <span class="material-icons fin-btn-icon">account_balance</span>Ana Kasa
            </button>
            <button class="fin-textbtn" style="color:#565e74" @click="openFullInventory">
              <span class="material-icons fin-btn-icon">inventory_2</span>Tüm Envanter
            </button>
            <div class="fin-chip fin-chip--indigo">
              <span class="fin-chip-value">Toplam {{ formatGram(zimmetTotalHasGram) }}</span>
            </div>
          </div>
        </div>
        <div class="fin-tablewrap">
          <table class="fin-table fin-table--wide">
            <thead>
              <tr>
                <th>Kullanıcı</th><th class="ta-c">Ürün Adedi</th><th class="ta-r">Toplam Has Gram</th><th class="ta-r">Detay</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(p, i) in zimmetSummary" :key="'z'+i">
                <td class="fw-500">{{ p.fullName }}</td>
                <td class="ta-c muted">{{ p.itemCount }}</td>
                <td class="ta-r fw-600" style="color:#4f46e5">{{ formatGram(p.totalHasGram) }}</td>
                <td class="ta-r">
                  <button class="fin-linkbtn" style="color:#4f46e5" @click="openZimmetDetail(p)">
                    <span class="material-icons fin-btn-icon">list</span>Detay
                  </button>
                </td>
              </tr>
              <tr v-if="!zimmetSummary || zimmetSummary.length === 0">
                <td colspan="4" class="fin-empty">Zimmetli kayıt yok</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section v-if="canViewAtolye" class="fin-card">
        <div class="fin-head fin-head--purple">
          <div class="fin-head-title">
            <span class="material-icons fin-head-icon" style="color:#7e22ce;font-size:24px">precision_manufacturing</span>
            <h2 class="fin-title" style="color:#7e22ce">Atölye</h2>
          </div>
          <div class="fin-head-actions">
            <button class="fin-textbtn" style="color:#9333ea" @click="openSendGold">
              <span class="material-icons fin-btn-icon">send</span>Atölyeye Altın Gönder
            </button>
            <button class="fin-textbtn" style="color:#9333ea" @click="openAtolyeHistory()">
              <span class="material-icons fin-btn-icon">history</span>Geçmiş
            </button>
            <div class="fin-chip fin-chip--purple">
              <span class="fin-chip-value">Toplam {{ formatGram(atolyeTotalBalance) }}</span>
            </div>
          </div>
        </div>
        <div class="fin-tablewrap">
          <table class="fin-table fin-table--wide">
            <thead>
              <tr>
                <th>Atölye</th><th class="ta-c">Bakiye (Has Gram)</th><th class="ta-r">İşlem</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(p, i) in atolyeBalances" :key="'a'+i">
                <td class="fw-500">{{ p.name }}</td>
                <td class="ta-c fw-600" style="color:#7e22ce">{{ formatGram(p.balance) }}</td>
                <td class="ta-r">
                  <button class="fin-linkbtn mr-2" style="color:#059669" @click="openReceiveProduct(p)">
                    <span class="material-icons fin-btn-icon">south_east</span>Ürün Girdisi
                  </button>
                  <button class="fin-linkbtn" style="color:#7e22ce" @click="openAtolyeHistory(p)">
                    <span class="material-icons fin-btn-icon">list</span>Geçmiş
                  </button>
                </td>
              </tr>
              <tr v-if="!atolyeBalances || atolyeBalances.length === 0">
                <td colspan="3" class="fin-empty">Atölye yok</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <v-dialog v-model="sendGoldDialog" max-width="640px" persistent>
        <v-card>
          <div class="fin-modal-head fin-modal-head--purple">
            <span class="material-icons fin-head-icon" style="color:#7e22ce;font-size:24px">send</span>
            <h2 class="fin-title" style="color:#7e22ce">Atölyeye Altın Gönder</h2>
          </div>
          <v-card-text class="pt-4">
            <template v-if="sendGoldStep === 1">
              <v-select v-model="sendGoldForm.atolyeId" :items="atolyeler" item-text="name" item-value="id" label="Atölye" dense></v-select>
              <div class="subtitle-2 mt-2 mb-1">Ne göndereceksiniz?</div>
              <v-radio-group v-model="sendGoldForm.kind" row class="mt-0">
                <v-radio label="Saf Altın" :value="0"></v-radio>
                <v-radio label="Ürün" :value="1"></v-radio>
              </v-radio-group>

              <template v-if="sendGoldForm.kind === 0">
                <div class="fin-pure-note" :class="{ 'fin-pure-note--err': (Number(sendGoldForm.grams) || 0) > pureGoldAvailable }">
                  <span class="material-icons" style="font-size:18px">savings</span>
                  Sistemdeki saf altın: <strong>{{ formatGram(pureGoldAvailable) }}</strong>
                </div>
                <v-text-field v-model.number="sendGoldForm.grams" label="Gram" type="number" min="0" :max="pureGoldAvailable" step="0.0001"></v-text-field>
              </template>

              <template v-if="sendGoldForm.kind === 1">
                <div class="caption grey--text mb-1">Envanterden ürün seçip adet giriniz:</div>
                <div class="fin-tablewrap">
                  <table class="fin-table">
                    <thead>
                      <tr><th>Ürün</th><th class="ta-c">Tip</th><th class="ta-r">Boşta</th><th class="ta-r">Birim Has</th><th class="ta-c">Adet</th></tr>
                    </thead>
                    <tbody>
                      <tr v-for="(pr, i) in sendProductRows" :key="'sp'+i">
                        <td class="fw-500">{{ pr.productName }}</td>
                        <td class="ta-c">{{ pr.inventoryTypeName }}</td>
                        <td class="ta-r">{{ pr.available }}</td>
                        <td class="ta-r">{{ formatGram(pr.hasPerUnit) }}</td>
                        <td class="ta-c" style="width:90px">
                          <v-text-field v-model.number="pr.qty" type="number" min="0" :max="pr.available" dense hide-details single-line style="width:70px"></v-text-field>
                        </td>
                      </tr>
                      <tr v-if="!sendProductRows || sendProductRows.length === 0"><td colspan="5" class="fin-empty">Gönderilebilir ürün yok</td></tr>
                    </tbody>
                  </table>
                </div>
                <div class="text-xs-right mt-2 subtitle-2" style="color:#7e22ce">Hesaplanan: {{ formatGram(sendProductTotalGram) }}</div>
              </template>

              <v-text-field v-model="sendGoldForm.paymentBarcode" label="İşlem Barkodu (opsiyonel)"></v-text-field>
              <v-textarea v-model="sendGoldForm.notes" label="Not (opsiyonel)" rows="2" auto-grow></v-textarea>
            </template>

            <template v-else-if="sendGoldStep === 2">
              <v-alert type="warning" dense text class="mb-2">Bu gönderimi onaylıyor musunuz?</v-alert>
              <div class="body-2"><strong>Atölye:</strong> {{ sendGoldAtolyeName }}</div>
              <div class="body-2"><strong>Tür:</strong> {{ sendGoldForm.kind === 0 ? 'Saf Altın' : 'Ürün' }}</div>
              <div class="body-2"><strong>Gönderilen:</strong> {{ formatGram(sendGoldEffectiveGram) }}</div>
            </template>

            <template v-else-if="sendGoldStep === 3 && sendGoldResult">
              <v-alert type="success" dense text class="mb-2">{{ sendGoldResult.message }}</v-alert>
              <div class="body-2">Atölye bakiyesi: {{ formatGram(sendGoldResult.balanceBefore) }} → <strong>{{ formatGram(sendGoldResult.balanceAfter) }}</strong></div>
            </template>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <template v-if="sendGoldStep === 1">
              <v-btn flat @click="sendGoldDialog = false">Vazgeç</v-btn>
              <v-btn color="deep-purple darken-1" dark depressed :disabled="!sendGoldValid" @click="sendGoldStep = 2">Devam</v-btn>
            </template>
            <template v-else-if="sendGoldStep === 2">
              <v-btn flat :disabled="sendGoldBusy" @click="sendGoldStep = 1">Geri</v-btn>
              <v-btn color="deep-purple darken-1" dark depressed :loading="sendGoldBusy" @click="confirmSendGold">Onayla</v-btn>
            </template>
            <template v-else>
              <v-btn color="primary" depressed @click="finishSendGold">Kapat</v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="receiveProductDialog" max-width="480px" persistent>
        <v-card v-if="receiveAtolye">
          <div class="fin-modal-head fin-modal-head--green">
            <span class="material-icons fin-head-icon" style="color:#047857;font-size:24px">call_received</span>
            <h2 class="fin-title" style="color:#047857">Ürün Girdisi — {{ receiveAtolye.name }}</h2>
          </div>
          <v-card-text class="pt-4">
            <div class="caption grey--text mb-2">Mevcut atölye bakiyesi: <strong>{{ formatGram(receiveAtolye.balance) }}</strong></div>
            <v-text-field v-model.number="receiveForm.grams" label="Alınan ürün (gram)" type="number" min="0" step="0.0001" autofocus></v-text-field>
            <v-text-field v-model="receiveForm.paymentBarcode" label="İşlem Barkodu (opsiyonel)"></v-text-field>
            <v-textarea v-model="receiveForm.notes" label="Not (opsiyonel)" rows="2" auto-grow></v-textarea>
            <v-alert type="info" dense text class="mt-1" v-if="Number(receiveForm.grams) > 0">
              Atölye bakiyesi: {{ formatGram(receiveAtolye.balance) }} → <strong>{{ formatGram(receiveAtolye.balance - (Number(receiveForm.grams) || 0)) }}</strong>
            </v-alert>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn flat :disabled="receiveBusy" @click="receiveProductDialog = false">Vazgeç</v-btn>
            <v-btn color="green darken-2" dark depressed :disabled="!(Number(receiveForm.grams) > 0)" :loading="receiveBusy" @click="confirmReceiveProduct">Onayla</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="atolyeHistoryDialog" max-width="1000px">
        <v-card>
          <div class="fin-modal-head fin-modal-head--purple">
            <span class="material-icons fin-head-icon" style="color:#7e22ce;font-size:24px">history</span>
            <h2 class="fin-title" style="color:#7e22ce">Atölye Geçmişi</h2>
            <button class="fin-modal-close" @click="atolyeHistoryDialog = false"><span class="material-icons" style="color:#7e22ce">close</span></button>
          </div>
          <v-layout wrap align-center class="px-3 pt-3">
            <v-flex xs12 sm3 class="px-1">
              <v-select v-model="atolyeHistoryFilter.atolyeId" :items="atolyeler" item-text="name" item-value="id"
                label="Atölye (boş = tümü)" clearable dense hide-details @change="loadAtolyeHistory"></v-select>
            </v-flex>
            <v-flex xs6 sm2 class="px-1">
              <v-menu v-model="atolyeStartMenu" :close-on-content-click="false" max-width="290">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="atolyeHistoryFilter.startDate" label="Başlangıç" readonly dense hide-details v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="atolyeHistoryFilter.startDate" @input="atolyeStartMenu = false; loadAtolyeHistory()"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 sm2 class="px-1">
              <v-menu v-model="atolyeEndMenu" :close-on-content-click="false" max-width="290">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="atolyeHistoryFilter.endDate" label="Bitiş" readonly dense hide-details v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="atolyeHistoryFilter.endDate" @input="atolyeEndMenu = false; loadAtolyeHistory()"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm3 class="px-1">
              <v-text-field v-model="atolyeHistoryFilter.barcode" label="Barkod ara" clearable dense hide-details
                @input="onAtolyeBarcodeSearch" prepend-inner-icon="search"></v-text-field>
            </v-flex>
          </v-layout>
          <v-card-text class="pa-0 pt-2">
            <div class="fin-tablewrap">
              <table class="fin-table">
                <thead>
                  <tr>
                    <th style="width:36px"></th>
                    <th>Tarih</th><th>Atölye</th><th class="ta-c">Tür</th><th class="ta-r">Gram</th>
                    <th>İşlem Barkodu</th><th class="ta-c">Bakiye (vardı → oldu)</th><th>Not</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(m, i) in atolyeHistory">
                    <tr :key="'am'+i" :class="{ 'fin-row-clickable': m.type === 2 && m.items && m.items.length }" @click="m.type === 2 && m.items && m.items.length ? toggleAtolyeRow(i) : null">
                      <td class="ta-c">
                        <span v-if="m.type === 2 && m.items && m.items.length" class="material-icons fin-expand-icon">{{ atolyeExpanded.indexOf(i) >= 0 ? 'expand_more' : 'chevron_right' }}</span>
                      </td>
                      <td>{{ formatDateOnly(m.createdDate) }}</td>
                      <td class="fw-500">{{ m.atolyeName }}</td>
                      <td class="ta-c">
                        <span class="fin-pill" :class="m.type === 3 ? 'fin-pill--green' : 'fin-pill--purple'">{{ m.typeText }}</span>
                      </td>
                      <td class="ta-r fw-500">{{ m.type === 3 ? '−' : '+' }}{{ formatGram(m.grams) }}</td>
                      <td>{{ m.paymentBarcode || '-' }}</td>
                      <td class="ta-c text-no-wrap">{{ m.balanceBefore == null ? '-' : formatGram(m.balanceBefore) }} → {{ m.balanceAfter == null ? '-' : formatGram(m.balanceAfter) }}</td>
                      <td>{{ m.notes || '-' }}</td>
                    </tr>
                    <tr v-if="m.type === 2 && m.items && m.items.length && atolyeExpanded.indexOf(i) >= 0" :key="'amd'+i" class="fin-detail-row">
                      <td></td>
                      <td colspan="7">
                        <div class="fin-detail-title">Gönderilen Ürünler</div>
                        <table class="fin-subtable">
                          <thead>
                            <tr><th>Ürün</th><th class="ta-c">Adet</th><th class="ta-r">Birim Has</th><th class="ta-r">Toplam Has</th></tr>
                          </thead>
                          <tbody>
                            <tr v-for="(it, j) in m.items" :key="'it'+i+'-'+j">
                              <td>{{ it.productName }}</td>
                              <td class="ta-c">{{ it.quantity }}</td>
                              <td class="ta-r">{{ formatGram(it.hasPerUnit) }}</td>
                              <td class="ta-r fw-600">{{ formatGram(it.hasGram) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </template>
                  <tr v-if="!atolyeHistory || atolyeHistory.length === 0">
                    <td colspan="8" class="fin-empty">{{ atolyeHistoryLoading ? 'Yükleniyor...' : 'Kayıt yok' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
          <v-card-actions class="pa-3"><v-spacer></v-spacer><v-btn flat @click="atolyeHistoryDialog = false">Kapat</v-btn></v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-dialog v-model="zimmetDetailDialog" max-width="900px">
      <v-card v-if="zimmetDetailUser">
        <div class="fin-modal-head fin-modal-head--indigo">
          <span class="material-icons fin-head-icon" style="color:#4338ca;font-size:24px">assignment_ind</span>
          <h2 class="fin-title" style="color:#4338ca">{{ zimmetDetailUser.fullName }} — Zimmet Detayı</h2>
          <span class="fin-modal-chip" style="color:#4338ca">Toplam: {{ formatGram(zimmetDetailUser.totalHasGram) }}</span>
          <button class="fin-modal-close" style="margin-left:8px" @click="zimmetDetailDialog = false"><span class="material-icons" style="color:#4338ca">close</span></button>
        </div>
        <v-card-text class="pa-3">
          <div class="fin-tablewrap">
            <table class="fin-table">
              <thead>
                <tr><th>Tip</th><th>Ürün</th><th>Seri No</th><th class="ta-c">Adet</th><th class="ta-r">Has Gram</th><th>Durum</th></tr>
              </thead>
              <tbody>
                <tr v-for="(p, i) in zimmetDetailLines" :key="'zd'+i">
                  <td>{{ p.inventoryTypeName }}</td>
                  <td class="fw-500">{{ p.productName }}</td>
                  <td>{{ p.serialNumber || '-' }}</td>
                  <td class="ta-c">{{ p.quantity }}</td>
                  <td class="ta-r fw-700">{{ formatGram(p.hasGram) }}</td>
                  <td>{{ p.statusName }}</td>
                </tr>
                <tr v-if="!zimmetDetailLines || zimmetDetailLines.length === 0"><td colspan="6" class="fin-empty">Kayıt yok</td></tr>
              </tbody>
            </table>
          </div>
        </v-card-text>
        <v-card-actions class="pa-3"><v-spacer></v-spacer><v-btn flat @click="zimmetDetailDialog = false">Kapat</v-btn></v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="mainVaultDialog" max-width="900px">
      <v-card>
        <div class="fin-modal-head fin-modal-head--grey">
          <span class="material-icons fin-head-icon" style="color:#475569;font-size:24px">account_balance</span>
          <h2 class="fin-title" style="color:#0f172a">Ana Kasa — Boştaki Stok</h2>
          <span class="fin-modal-chip">Toplam {{ formatGram(mainVaultTotalHas) }}</span>
          <button class="fin-modal-close" style="margin-left:8px" @click="mainVaultDialog = false"><span class="material-icons" style="color:#475569">close</span></button>
        </div>
        <v-card-text class="pa-3">
          <div class="fin-tablewrap">
            <table class="fin-table">
              <thead>
                <tr><th>Tip</th><th>Ürün</th><th>Seri No</th><th class="ta-c">Adet</th><th class="ta-r">Has Gram</th><th>Durum</th></tr>
              </thead>
              <tbody>
                <tr v-for="(p, i) in mainVaultLines" :key="'mv'+i">
                  <td>{{ p.inventoryTypeName }}</td>
                  <td class="fw-500">{{ p.productName }}</td>
                  <td>{{ p.serialNumber || '-' }}</td>
                  <td class="ta-c">{{ p.quantity }}</td>
                  <td class="ta-r fw-500">{{ formatGram(p.hasGram) }}</td>
                  <td>{{ p.statusName }}</td>
                </tr>
                <tr v-if="!mainVaultLines || mainVaultLines.length === 0"><td colspan="6" class="fin-empty">{{ mainVaultLoading ? 'Yükleniyor...' : 'Boşta stok yok' }}</td></tr>
              </tbody>
            </table>
          </div>
        </v-card-text>
        <v-card-actions class="pa-3"><v-spacer></v-spacer><v-btn flat @click="mainVaultDialog = false">Kapat</v-btn></v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="fullInventoryDialog" max-width="900px">
      <v-card>
        <div class="fin-modal-head fin-modal-head--teal">
          <span class="material-icons fin-head-icon" style="color:#0f766e;font-size:24px">inventory_2</span>
          <h2 class="fin-title" style="color:#0f766e">Tüm Envanter</h2>
          <span class="fin-modal-chip" style="color:#0f766e">Toplam Has {{ formatGram(fullInventoryTotalHas) }}</span>
          <button class="fin-modal-close" style="margin-left:8px" @click="fullInventoryDialog = false"><span class="material-icons" style="color:#0f766e">close</span></button>
        </div>
        <v-card-text class="pa-3">
          <div class="fin-tablewrap">
            <table class="fin-table">
              <thead>
                <tr><th>Tip</th><th>Ürün</th><th class="ta-c">Ayar</th><th class="ta-c">Adet</th><th class="ta-r">Has Gram</th></tr>
              </thead>
              <tbody>
                <tr v-for="(p, i) in fullInventoryItems" :key="'fi'+i">
                  <td>{{ p.inventoryTypeName }}</td>
                  <td class="fw-500">{{ p.productName }}</td>
                  <td class="ta-c">{{ p.purityLabel || p.purity }}</td>
                  <td class="ta-c">{{ p.quantity }}</td>
                  <td class="ta-r fw-500">{{ formatGram(p.hasGram) }}</td>
                </tr>
                <tr v-if="!fullInventoryItems || fullInventoryItems.length === 0"><td colspan="5" class="fin-empty">{{ fullInventoryLoading ? 'Yükleniyor...' : 'Envanter boş' }}</td></tr>
              </tbody>
            </table>
          </div>
        </v-card-text>
        <v-card-actions class="pa-3"><v-spacer></v-spacer><v-btn flat @click="fullInventoryDialog = false">Kapat</v-btn></v-card-actions>
      </v-card>
    </v-dialog>

    <v-container grid-list-xl>
      <v-layout wrap justify-space-between>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title
              >Has Ortalama: {{ hasAverage | formatMoney }}</v-toolbar-title
            >
          </v-toolbar>
          <v-toolbar flat color="white">
            <v-toolbar-title>Bugünkü Siparişler</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.$store.state.reports.orderReports"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  {{ props.item.state | formatState }}
                </td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>

        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Bugünkü Uyum Fatura Durumları</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.uyumDaily"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  {{ props.item.state | formatUyumStates }}
                </td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Siparişler Son 1 Ay</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.orderMonthly"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  {{ props.item.state | formatState }}
                </td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Uyum Fatura Durumları Son 1 Ay</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.uyumMonthly"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  {{ props.item.state | formatUyumStates }}
                </td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Bugün En Çok Satılanlar</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="productHeaders"
            :loading="this.$store.state.progress"
            :items="this.$store.state.reports.bestSellingProducts"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">{{ props.item.productName }}</td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>

        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>En Çok Satılanlar Son 1 Ay</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="productHeaders"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.productMonthly"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">{{ props.item.productName }}</td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>

        <!-- Tarih Aralığına Göre Gönderilen Altın Özeti -->
        <v-flex xs12 class="mb-4">
          <v-card class="elevation-4">
            <v-card-title class="primary white--text">
              <v-icon left color="white">date_range</v-icon>
              <span class="font-weight-bold">Tarih Aralığına Göre Gönderilen Altın Özeti</span>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-layout row wrap class="mb-3">
                <v-flex xs12 sm4 class="px-2">
                  <v-menu
                    v-model="goldSentStartDateMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="goldSentStartDate"
                        label="Başlangıç Tarihi"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="goldSentStartDate"
                      locale="tr-TR"
                      @input="goldSentStartDateMenu = false; loadTotalGoldSentBetweenDates()"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm4 class="px-2">
                  <v-menu
                    v-model="goldSentEndDateMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="goldSentEndDate"
                        label="Bitiş Tarihi"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="goldSentEndDate"
                      locale="tr-TR"
                      @input="goldSentEndDateMenu = false; loadTotalGoldSentBetweenDates()"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-data-table
                :headers="goldSentHeaders"
                :items="goldSentTableItems"
                :loading="goldSentLoading"
                hide-actions
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <tr>
                    <td>{{ props.item.label }}</td>
                    <td class="text-xs-right font-weight-bold">{{ props.item.value }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

        <!-- E-Altın Banka Özetleri (Sadece TenantId = 2 için) -->
        <v-flex xs12 mt-4 v-if="tenantId === 2">
          <v-layout row wrap>
            <!-- Yeni Sipariş Toplamları Tablosu -->
            <v-flex xs12 md6>
              <v-card class="elevation-4">
                <v-card-title class="amber darken-2 white--text">
                  <v-icon left color="white">new_releases</v-icon>
                  <span class="font-weight-bold">Banka Bazında Yeni Sipariş Toplamları</span>
                </v-card-title>
                
                <v-card-text class="pa-3">
                  <!-- Filtre -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 sm6 class="px-2">
                      <v-menu
                        v-model="newOrdersStartDateMenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="newOrdersStartDate"
                            label="Başlangıç Tarihi"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newOrdersStartDate"
                          locale="tr-TR"
                          @input="newOrdersStartDateMenu = false; loadNewOrdersSummary()"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 class="px-2">
                      <v-menu
                        v-model="newOrdersEndDateMenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="newOrdersEndDate"
                            label="Bitiş Tarihi"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newOrdersEndDate"
                          locale="tr-TR"
                          @input="newOrdersEndDateMenu = false; loadNewOrdersSummary()"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>

                  <!-- Tablo -->
                  <v-data-table
                    :headers="newOrdersHeaders"
                    :items="newOrdersSummary"
                    :loading="newOrdersLoading"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <tr :class="props.item.bankName === 'DİĞER (1000 milyem)' ? 'grey lighten-3' : ''">
                        <td class="font-weight-bold">{{ props.item.bankName }}</td>
                        <td class="text-xs-right">{{ formatGold(props.item.currentGoldAmount) }}</td>
                        <td class="text-xs-right amber--text text--darken-3 font-weight-bold">
                          {{ formatGold(props.item.totalGoldAmount) }}
                        </td>
                      </tr>
                    </template>
                    <template v-slot:no-data>
                      <v-alert :value="true" color="info" icon="info">
                        Seçilen tarih aralığında yeni sipariş bulunmamaktadır.
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Gönderilen Sipariş Toplamları Tablosu -->
            <v-flex xs12 md6>
              <v-card class="elevation-4">
                <v-card-title class="success white--text">
                  <v-icon left color="white">done_all</v-icon>
                  <span class="font-weight-bold">Banka Bazında Gönderilen Sipariş Toplamları</span>
                </v-card-title>
                
                <v-card-text class="pa-3">
                  <!-- Filtre -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 class="px-2">
                      <v-menu
                        v-model="completedOrdersDateMenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="completedOrdersDate"
                            label="İşlem Tarihi"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="completedOrdersDate"
                          locale="tr-TR"
                          @input="completedOrdersDateMenu = false; loadCompletedOrdersSummary()"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>

                  <!-- Tablo -->
                  <v-data-table
                    :headers="completedOrdersHeaders"
                    :items="completedOrdersSummary"
                    :loading="completedOrdersLoading"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <tr>
                        <td class="font-weight-bold">{{ props.item.bankName }}</td>
                        <td class="text-xs-right">{{ formatGold(props.item.currentGoldAmount) }}</td>
                        <td class="text-xs-right success--text font-weight-bold">
                          {{ formatGold(props.item.totalGoldAmount) }}
                        </td>
                      </tr>
                    </template>
                    <template v-slot:no-data>
                      <v-alert :value="true" color="info" icon="info">
                        Seçilen tarihte gönderilen sipariş bulunmamaktadır.
                      </v-alert>
                    </template>
                    <template v-slot:footer v-if="completedOrdersSummary.length">
                      <tr class="success lighten-4" style="border-top: 2px solid #4caf50;">
                        <td class="font-weight-bold text-uppercase">Toplam</td>
                        <td class="text-xs-right font-weight-bold">{{ formatGold(completedOrdersTotalCurrentGold) }}</td>
                        <td class="text-xs-right success--text font-weight-bold">{{ formatGold(completedOrdersTotalGold) }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <!-- Gün Bazında Sipariş Kontrol -->
          <v-layout row wrap class="mt-4">
            <v-flex xs12>
              <v-card class="elevation-4">
                <v-card-title class="indigo darken-2 white--text">
                  <v-icon left color="white">table_chart</v-icon>
                  <span class="font-weight-bold">Gün Bazında Sipariş Kontrol</span>
                </v-card-title>

                <v-card-text class="pa-3">
                  <!-- Filtre -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 sm4 class="px-2">
                      <v-menu
                        v-model="ealtinOrderControlDateMenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="ealtinOrderControlDate"
                            label="Tarih"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="ealtinOrderControlDate"
                          locale="tr-TR"
                          @input="ealtinOrderControlDateMenu = false; loadEaltinOrderControl()"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm4 class="px-2">
                      <v-combobox
                        v-model="selectedEaltinOrderControlCities"
                        :items="ealtinOrderControlCityOptions"
                        label="Şehir"
                        prepend-icon="location_city"
                        multiple
                        clearable
                        dense
                      ></v-combobox>
                    </v-flex>
                    <v-flex xs12 sm4 class="px-2 d-flex flex-column align-end justify-center">
                      <span class="red--text font-weight-bold">
                        Toplam: {{ formatNumber(ealtinOrderControlTotalExpectedSum) }}
                      </span>
                      <span class="red--text font-weight-bold caption text-right">
                        {{ formatNumber(ealtinOrderControlTotalWithNewOrders) }}
                        <span class="grey--text text--darken-1">(yeni siparişlerle birlikte beklenen)</span>
                      </span>
                    </v-flex>
                  </v-layout>

                  <!-- Özet (tablodaki verilerden) -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam KDV</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.totalVat + ealtinOrderControlTotals.commissionVat) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam Stopaj</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.withholding) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam İşçilik</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.labor) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam Komisyon</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.commission) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam Komisyon KDV'li</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.commissionWithVat) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam Hizmet Bedeli</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.serviceFee) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Ortalama Has</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlAverages.avgHasPrice) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Ortalama Satış Fiyatı</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlAverages.avgSalesPrice) }}
                        </div>
                      </v-card>
                    </v-flex>
                  </v-layout>

                  <!-- Tablo -->
                  <v-data-table
                    :headers="ealtinOrderControlHeaders"
                    :items="filteredEaltinOrderControlList"
                    :loading="ealtinOrderControlLoading"
                    :pagination.sync="ealtinOrderControlPagination"
                    hide-actions
                    class="elevation-1 ealtin-order-control-table"
                  >
                    <template v-slot:items="props">
                      <tr>
                        <td>{{ formatDateOnly(props.item.date) }}</td>
                        <td class="text-no-wrap">{{ props.item.iban }}</td>
                        <td class="text-no-wrap">{{ props.item.bank }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.grams) }}</td>
                        <td class="text-no-wrap">{{ props.item.orderNumber }}</td>
                        <td class="text-no-wrap">{{ props.item.customerName }}</td>
                        <td class="text-no-wrap">{{ props.item.shippingCity }}</td>
                        <td class="text-no-wrap">{{ props.item.productCode }}</td>
                        <td class="text-xs-right">{{ props.item.quantity }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.unitPrice) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.invoiceAmount) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.commission) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.commissionVat) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.commissionWithVat) }}</td>
                        <td class="text-xs-right">{{ formatNumber((props.item.totalVat || 0) + (props.item.commissionVat || 0)) }}</td>
                        <td class="text-xs-right font-weight-bold">{{ formatNumber(props.item.totalExpected) }}</td>
                        <td class="text-xs-right">{{ formatGramTruncate(props.item.totalGramWeight) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.hasPrice) }}</td>
                        <td class="text-xs-right">{{ props.item.foreksHas == null ? '-' : formatNumber(props.item.foreksHas) }}</td>
                        <td class="text-xs-right">{{ props.item.averageSalesExchange == null ? '-' : formatNumber(props.item.averageSalesExchange) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.salesAmount) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.labor) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.totalVat) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.laborWithVat) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.withholding) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.serviceFee) }}</td>
                      </tr>
                    </template>
                    <template v-slot:no-data>
                      <v-alert :value="true" color="info" icon="info">
                        Seçilen tarihte kayıt bulunmamaktadır.
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <mint-agreement-summary-card ref="mintSummaryCard" />

        <!-- Altındafırsat Gün Bazında Sipariş Kontrol (Sadece TenantId = 1 için) -->
        <v-flex xs12 mt-4 v-if="tenantId === 1">
          <v-card class="elevation-4">
            <v-card-title class="amber darken-3 white--text">
              <v-icon left color="white">assignment_turned_in</v-icon>
              <span class="font-weight-bold">Gün Bazında Sipariş Kontrol</span>
              <v-spacer></v-spacer>
              <v-btn small color="white" class="amber--text text--darken-3 ma-0" @click="openBarcodeDialog">
                <v-icon left small>qr_code_scanner</v-icon>
                Barkod Okut
              </v-btn>
            </v-card-title>

            <v-card-text class="pa-3">
              <!-- Tarih Filtresi -->
              <v-layout row wrap class="mb-3">
                <v-flex xs12 sm3 class="px-2">
                  <v-menu
                    v-model="altindafirsatOrderControlDateMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="altindafirsatOrderControlDate"
                        label="Tarih"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="altindafirsatOrderControlDate"
                      locale="tr-TR"
                      @input="altindafirsatOrderControlDateMenu = false; loadAltindafirsatOrderControl()"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm3 class="px-2">
                  <v-combobox
                    v-model="selectedAltindafirsatOrderControlCities"
                    :items="altindafirsatOrderControlCityOptions"
                    label="Şehir"
                    prepend-icon="location_city"
                    multiple
                    clearable
                    dense
                  ></v-combobox>
                </v-flex>
                <v-flex xs12 sm3 class="px-2 d-flex align-center">
                  <v-menu offset-y :close-on-content-click="false" max-height="420">
                    <template v-slot:activator="{ on }">
                      <v-btn small color="amber darken-3" class="white--text" v-on="on">
                        <v-icon left small>view_column</v-icon>
                        Sütunlar ({{ altindafirsatToggleableColumns.length - altindafirsatHiddenColumns.length }}/{{ altindafirsatToggleableColumns.length }})
                      </v-btn>
                    </template>
                    <v-card>
                      <v-list dense class="py-0">
                        <v-list-tile @click="toggleAllAltindafirsatColumns">
                          <v-list-tile-action>
                            <v-icon small>{{ altindafirsatHiddenColumns.length === 0 ? 'check_box' : (altindafirsatHiddenColumns.length === altindafirsatToggleableColumns.length ? 'check_box_outline_blank' : 'indeterminate_check_box') }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title class="font-weight-bold">Tümünü Seç / Kaldır</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>
                        <v-list-tile
                          v-for="col in altindafirsatToggleableColumns"
                          :key="col.value"
                          @click="toggleAltindafirsatColumn(col.value)"
                        >
                          <v-list-tile-action>
                            <v-icon small>{{ altindafirsatHiddenColumns.includes(col.value) ? 'check_box_outline_blank' : 'check_box' }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>{{ col.text }}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-card>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm3 class="px-2 d-flex align-center justify-end">
                  <span class="red--text font-weight-bold">
                    Toplam Fatura: {{ formatNumber(altindafirsatTotals.invoiceAmount) }}
                  </span>
                </v-flex>
              </v-layout>

              <!-- Özet Kartları -->
              <v-layout row wrap class="mb-3">
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam Komisyon (KDV'li)</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.commissionWithVat) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam Sigorta (KDV'li)</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.insuranceWithVat) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam İşçilik (KDV'li)</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.laborInclVat) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam Stopaj</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.withholding) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam Fatura KDV</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.invoiceVat) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam Net Satış Tutarı</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.netSalesAmount) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">HB'den Beklenen Nakit</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.netCash) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2" style="border-color:#e53935;">
                    <div class="caption red--text text--darken-1">Yeni Siparişlerle Birlikte Toplam Beklenen</div>
                    <div class="subtitle-1 font-weight-bold red--text">
                      {{ formatNumber(altindafirsatOrderControlTotalWithNewOrders) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam G.gramaj</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.totalPureGram) }}
                    </div>
                  </v-card>
                </v-flex>
              </v-layout>

              <!-- Tablo -->
              <v-data-table
                :headers="altindafirsatVisibleHeaders"
                :items="filteredAltindafirsatOrderControlList"
                :loading="altindafirsatOrderControlLoading"
                :pagination.sync="altindafirsatOrderControlPagination"
                hide-actions
                class="elevation-1 altindafirsat-order-control-table"
              >
                <template v-slot:items="props">
                  <tr>
                    <td class="text-xs-right">{{ props.item.rowNo }}</td>
                    <td class="text-no-wrap">{{ props.item.indicator }}</td>
                    <td class="text-no-wrap">{{ formatDateTime(props.item.orderDate) }}</td>
                    <td class="text-no-wrap">{{ props.item.barcode }}</td>
                    <td class="text-no-wrap">{{ props.item.identityNo }}</td>
                    <td class="text-no-wrap">{{ props.item.orderNumber }}</td>
                    <td class="text-no-wrap">{{ props.item.customerName }}</td>
                    <td class="text-no-wrap">{{ props.item.shippingCity }}</td>
                    <td class="text-no-wrap">{{ props.item.productName }}</td>
                    <td class="text-xs-right">{{ props.item.quantity }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.unitPrice) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.invoiceAmount) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('commission')" class="text-xs-right">{{ formatNumber(props.item.commission) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('commissionVat')" class="text-xs-right">{{ formatNumber(props.item.commissionVat) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('commissionWithVat')" class="text-xs-right">{{ formatNumber(props.item.commissionWithVat) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('insurance')" class="text-xs-right">{{ formatNumber(props.item.insurance) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('insuranceVat')" class="text-xs-right">{{ formatNumber(props.item.insuranceVat) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('insuranceWithVat')" class="text-xs-right">{{ formatNumber(props.item.insuranceWithVat) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('commissionPlusInsurance')" class="text-xs-right">{{ formatNumber(props.item.commissionPlusInsurance) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('commissionVatPlusInsuranceVat')" class="text-xs-right">{{ formatNumber(props.item.commissionVatPlusInsuranceVat) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('invoiceVat')" class="text-xs-right">{{ formatNumber(props.item.invoiceVat) }}</td>
                    <td class="text-xs-right font-weight-bold">{{ formatNumber(props.item.netCash) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.withholding) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.unitGram) }}</td>
                    <td class="text-xs-right">{{ props.item.purity }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.totalRawGram) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.totalPureGram) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.salesHasPrice) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.netSalesAmount) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.labor) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.laborVat) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.laborInclVat) }}</td>
                    <td class="text-no-wrap">{{ props.item.link }}</td>
                    <td class="text-no-wrap">{{ props.item.shippingStatus }}</td>
                    <td class="text-no-wrap">{{ props.item.shippedBarcode }}</td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  <v-alert :value="true" color="info" icon="info">
                    Seçilen tarihte kayıt bulunmamaktadır.
                  </v-alert>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="barcodeDialogOpen" persistent max-width="640">
      <v-card>
        <v-card-title class="amber darken-3 white--text">
          <v-icon left color="white">qr_code_scanner</v-icon>
          <span class="font-weight-bold">Barkod Okut</span>
          <v-spacer></v-spacer>
          <v-btn icon flat color="white" @click="closeBarcodeDialog" :disabled="barcodeConfirming">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-text-field
            ref="barcodeInputRef"
            v-model="barcodeInput"
            label="Barkod"
            placeholder="Barkodu okutun veya yazıp Enter'a basın"
            prepend-icon="qr_code"
            autofocus
            clearable
            @keyup.enter="addBarcode"
            @blur="onBarcodeInputBlur"
            :disabled="barcodeConfirming"
          ></v-text-field>

          <v-alert
            v-if="duplicateBarcodeWarning"
            :value="true"
            type="warning"
            color="orange darken-2"
            icon="warning"
            outline
            class="mb-2 py-2"
          >
            <strong>Bu barkod zaten okutuldu:</strong>
            <span class="font-weight-bold">{{ duplicateBarcodeWarning }}</span>
            <div class="caption">Yeni bir barkod okutarak devam edebilirsiniz.</div>
          </v-alert>

          <div class="caption grey--text mb-2">
            {{ scannedBarcodes.length }} barkod listede. Tek tek veya art arda okutabilirsiniz.
          </div>

          <v-list dense v-if="scannedBarcodes.length" class="elevation-1" style="max-height:220px;overflow-y:auto">
            <v-list-tile
              v-for="(b, idx) in scannedBarcodes"
              :key="idx"
              :class="{ 'duplicate-flash': duplicateFlashIdx === idx }"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ b }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon flat small @click="removeBarcode(idx)" :disabled="barcodeConfirming">
                  <v-icon small color="red">delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>

          <div v-if="barcodeConfirmResult" class="mt-3">
            <v-card
              v-if="barcodeConfirmResult.confirmed && barcodeConfirmResult.confirmed.length"
              flat
              class="pa-2 mb-2 barcode-result-card"
              style="border-left:4px solid #43a047;background:#f1f8e9"
            >
              <div class="d-flex align-center mb-1">
                <v-icon small color="green darken-2">check_circle</v-icon>
                <span class="font-weight-bold green--text text--darken-2 ml-2">
                  Onaylanan ({{ barcodeConfirmResult.confirmed.length }})
                </span>
              </div>
              <div>
                <v-chip
                  v-for="b in barcodeConfirmResult.confirmed"
                  :key="'c-' + b"
                  small
                  color="green lighten-4"
                  text-color="green darken-3"
                  class="ma-1"
                >{{ b }}</v-chip>
              </div>
            </v-card>

            <v-card
              v-if="barcodeConfirmResult.alreadyConfirmed && barcodeConfirmResult.alreadyConfirmed.length"
              flat
              class="pa-2 mb-2 barcode-result-card"
              style="border-left:4px solid #fb8c00;background:#fff8e1"
            >
              <div class="d-flex align-center mb-1">
                <v-icon small color="orange darken-2">info</v-icon>
                <span class="font-weight-bold orange--text text--darken-2 ml-2">
                  Zaten Onaylı ({{ barcodeConfirmResult.alreadyConfirmed.length }})
                </span>
              </div>
              <div>
                <v-chip
                  v-for="b in barcodeConfirmResult.alreadyConfirmed"
                  :key="'a-' + b"
                  small
                  color="orange lighten-4"
                  text-color="orange darken-3"
                  class="ma-1"
                >{{ b }}</v-chip>
              </div>
            </v-card>

            <v-card
              v-if="barcodeConfirmResult.notShipped && barcodeConfirmResult.notShipped.length"
              flat
              class="pa-2 mb-2 barcode-result-card"
              style="border-left:4px solid #c62828;background:#ffebee"
            >
              <div class="d-flex align-center mb-1">
                <v-icon small color="red darken-2">local_shipping</v-icon>
                <span class="font-weight-bold red--text text--darken-2 ml-2">
                  Kargo gönderildi durumuna çekilmeyenler ({{ barcodeConfirmResult.notShipped.length }})
                </span>
              </div>
              <div>
                <v-chip
                  v-for="b in barcodeConfirmResult.notShipped"
                  :key="'s-' + b"
                  small
                  color="red lighten-4"
                  text-color="red darken-3"
                  class="ma-1"
                >{{ b }}</v-chip>
              </div>
            </v-card>

            <v-card
              v-if="barcodeConfirmResult.notFound && barcodeConfirmResult.notFound.length"
              flat
              class="pa-2 mb-2 barcode-result-card"
              style="border-left:4px solid #424242;background:#fafafa"
            >
              <div class="d-flex align-center mb-1">
                <v-icon small color="grey darken-3">error_outline</v-icon>
                <span class="font-weight-bold grey--text text--darken-3 ml-2">
                  Bulunamayan/Geçersiz ({{ barcodeConfirmResult.notFound.length }})
                </span>
              </div>
              <div>
                <v-chip
                  v-for="b in barcodeConfirmResult.notFound"
                  :key="'n-' + b"
                  small
                  color="grey lighten-2"
                  text-color="grey darken-4"
                  class="ma-1"
                >{{ b }}</v-chip>
              </div>
            </v-card>

            <v-alert
              v-if="barcodeConfirmResult.ykFailed && barcodeConfirmResult.ykFailed.length"
              :value="true"
              type="warning"
              outlined
              class="mt-2 mb-0"
            >
              <strong>{{ (barcodeConfirmResult.ykSuccess || []).length }}</strong> sipariş Yurtiçi Kargo'ya gönderildi,
              <strong>{{ barcodeConfirmResult.ykFailed.length }}</strong> tanesinde sorun var.
              <router-link to="/kargo-bilgileri" class="orange--text text--darken-3 font-weight-bold">
                Kargo Bilgileri sayfasından kontrol edin ›
              </router-link>
            </v-alert>
            <v-alert
              v-else-if="barcodeConfirmResult.ykSuccess && barcodeConfirmResult.ykSuccess.length"
              :value="true"
              type="success"
              outlined
              class="mt-2 mb-0"
            >
              <strong>{{ barcodeConfirmResult.ykSuccess.length }}</strong> sipariş Yurtiçi Kargo'ya başarıyla gönderildi.
            </v-alert>
          </div>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-btn flat @click="clearBarcodes" :disabled="barcodeConfirming || !scannedBarcodes.length">
            Listeyi Temizle
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeBarcodeDialog" :disabled="barcodeConfirming">Kapat</v-btn>
          <v-btn
            color="amber darken-3"
            class="white--text"
            :loading="barcodeConfirming"
            :disabled="!scannedBarcodes.length || barcodeConfirming"
            @click="confirmBarcodes"
          >
            <v-icon left small>check</v-icon>
            Onayla
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import store from "@/store";
import Api from "@/api/baseApi";
import orders from "@/api/orders";
import yurticiKargoApi from "@/api/yurticiKargo";
import MintAgreementSummaryCard from "@/components/MintAgreementSummaryCard.vue";

export default {
  components: {
    MintAgreementSummaryCard,
  },
  filters: {
    formatState: function(value) {
      var result = store.getters["orders/getStateItems"].find(
        (el) => el.id == value
      );
      return result.value;
    },
  },
  data: () => {
    const d = new Date();
    const start = new Date(d);
    start.setDate(start.getDate() - 30);
    const end = new Date(d);
    end.setDate(end.getDate() + 1);
    return {
    // Tarih aralığına göre gönderilen altın (varsayılan: son 1 ay)
    goldSentStartDate: start.toISOString().substr(0, 10),
    goldSentEndDate: end.toISOString().substr(0, 10),
    goldSentStartDateMenu: false,
    goldSentEndDateMenu: false,
    goldSentLoading: false,
    goldSentData: { totalGoldSent: 0, totalPayment: 0 },
    goldSentHeaders: [
      { text: 'Özet', value: 'label', sortable: false },
      { text: 'Değer', value: 'value', align: 'right', sortable: false }
    ],
    productMonthly: [],
    orderMonthly: [],
    uyumMonthly: [],
    uyumDaily: [],
    hasAverage: null,
    pagination: {
      sortBy: "name",
    },
    pageItems: [
      25,
      50,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
    ],
    headers: [
      {
        text: "Sipariş Durumu",
        value: "state",
      },
      { text: "Adet", value: "count" },
      { text: "Sipariş Tutarı", value: "totalAmount" },
    ],
    productHeaders: [
      {
        text: "Ürün",
        value: "state",
      },
      { text: "Adet", value: "count" },
      { text: "Sipariş Tutarı", value: "totalAmount" },
    ],
    // E-Altın Banka Özetleri
    newOrdersStartDate: new Date().toISOString().substr(0, 10),
    newOrdersEndDate: new Date().toISOString().substr(0, 10),
    newOrdersStartDateMenu: false,
    newOrdersEndDateMenu: false,
    newOrdersSummary: [],
    newOrdersLoading: false,
    newOrdersHeaders: [
      { text: 'Banka Adı', value: 'bankName', sortable: false },
      { text: 'Bankadaki Altın Miktarı(GR)', value: 'currentGoldAmount', align: 'right', sortable: false },
      { text: 'Yeni Sipariş Toplamı(GR)', value: 'totalGoldAmount', align: 'right', sortable: false }
    ],
    completedOrdersDate: new Date().toISOString().substr(0, 10),
    completedOrdersDateMenu: false,
    completedOrdersSummary: [],
    completedOrdersLoading: false,
    completedOrdersHeaders: [
      { text: 'Banka Adı', value: 'bankName', sortable: false },
      { text: 'Bankadaki Altın Miktarı(GR)', value: 'currentGoldAmount', align: 'right', sortable: false },
      { text: 'Gönderilen Altın Toplamı(GR)', value: 'totalGoldAmount', align: 'right', sortable: false }
    ],

    // Gün Bazında Sipariş Kontrol (E-Altın)
    ealtinOrderControlDate: new Date().toISOString().substr(0, 10),
    ealtinOrderControlDateMenu: false,
    ealtinOrderControlLoading: false,
    ealtinOrderControlList: [],
    ealtinNewOrdersExpectedTotal: 0,
    ealtinOrderControlPagination: { rowsPerPage: -1 },
    selectedEaltinOrderControlCities: [],
    ealtinOrderControlHeaders: [
      { text: 'Tarih', value: 'date', sortable: false },
      { text: 'IBAN', value: 'iban', sortable: false },
      { text: 'BANKA', value: 'bank', sortable: false },
      { text: 'GRAM', value: 'grams', align: 'right', sortable: false },
      { text: 'SİPARİŞ NO', value: 'orderNumber', sortable: false },
      { text: 'İSİM', value: 'customerName', sortable: false },
      { text: 'ŞEHİR', value: 'shippingCity', sortable: false },
      { text: 'KOD(Ürün adı)', value: 'productCode', sortable: false },
      { text: 'Adet', value: 'quantity', align: 'right', sortable: false },
      { text: 'Birim Fiyatı', value: 'unitPrice', align: 'right', sortable: false },
      { text: 'Fatura Tutarı', value: 'invoiceAmount', align: 'right', sortable: false },
      { text: 'Komisyon', value: 'commission', align: 'right', sortable: false },
      { text: 'Komisyon KDVSİ', value: 'commissionVat', align: 'right', sortable: false },
      { text: 'Komisyon + komisyon Kdvsi', value: 'commissionWithVat', align: 'right', sortable: false },
      { text: 'Toplam KDV', value: 'eGoldVat', align: 'right', sortable: false },
      { text: 'Toplam', value: 'totalExpected', align: 'right', sortable: false },
      { text: 'Toplam Gramaj', value: 'totalGramWeight', align: 'right', sortable: false },
      { text: 'Has Fiyatı', value: 'hasPrice', align: 'right', sortable: false },
      { text: 'Foreks Has', value: 'foreksHas', align: 'right', sortable: false },
      { text: 'Ortalama Satış Döviz', value: 'averageSalesExchange', align: 'right', sortable: false },
      { text: 'Satış Tutarı', value: 'salesAmount', align: 'right', sortable: false },
      { text: 'İşçilik', value: 'labor', align: 'right', sortable: false },
      { text: 'İşçilik KDVsi', value: 'totalVat', align: 'right', sortable: false },
      { text: 'Kdvli İşçilik', value: 'laborWithVat', align: 'right', sortable: false },
      { text: 'Stopaj', value: 'withholding', align: 'right', sortable: false },
      { text: 'Hizmet Bedeli', value: 'serviceFee', align: 'right', sortable: false },
    ],

    // Altındafırsat Gün Bazında Sipariş Kontrol
    altindafirsatOrderControlDate: new Date().toISOString().substr(0, 10),
    altindafirsatOrderControlDateMenu: false,
    altindafirsatOrderControlLoading: false,
    altindafirsatOrderControlList: [],
    altindafirsatNewOrdersExpectedTotal: 0,
    altindafirsatOrderControlPagination: { rowsPerPage: -1 },
    selectedAltindafirsatOrderControlCities: [],

    // Barkod Okutma Modal
    barcodeDialogOpen: false,
    barcodeInput: '',
    scannedBarcodes: [],
    barcodeConfirming: false,
    barcodeConfirmResult: null,
    duplicateBarcodeWarning: null,
    duplicateFlashIdx: null,
    duplicateFlashTimer: null,
    altindafirsatOrderControlHeaders: [
      { text: 'Sıra No', value: 'rowNo', align: 'right', sortable: false },
      { text: 'Etiket No', value: 'indicator', sortable: false },
      { text: 'Sipariş Tarihi', value: 'orderDate', sortable: false },
      { text: 'Barkod', value: 'barcode', sortable: false },
      { text: 'T.C Kimlik No', value: 'identityNo', sortable: false },
      { text: 'Sipariş No', value: 'orderNumber', sortable: false },
      { text: 'İsim', value: 'customerName', sortable: false },
      { text: 'Şehir', value: 'shippingCity', sortable: false },
      { text: 'Ürün', value: 'productName', sortable: false },
      { text: 'Adet', value: 'quantity', align: 'right', sortable: false },
      { text: 'Birim Fiyatı', value: 'unitPrice', align: 'right', sortable: false },
      { text: 'Fatura Tutarı', value: 'invoiceAmount', align: 'right', sortable: false },
      { text: 'HB Kom.', value: 'commission', align: 'right', sortable: false },
      { text: 'HB KDV', value: 'commissionVat', align: 'right', sortable: false },
      { text: 'HB KOM.+ KDV', value: 'commissionWithVat', align: 'right', sortable: false },
      { text: 'Sigorta Bedeli', value: 'insurance', align: 'right', sortable: false },
      { text: 'Sigorta KDV', value: 'insuranceVat', align: 'right', sortable: false },
      { text: 'KDVLİ Sigorta Bedeli', value: 'insuranceWithVat', align: 'right', sortable: false },
      { text: 'HB KOM.+ Sigorta', value: 'commissionPlusInsurance', align: 'right', sortable: false },
      { text: 'HB KDV+ Sigorta KDV', value: 'commissionVatPlusInsuranceVat', align: 'right', sortable: false },
      { text: 'FT. KDV', value: 'invoiceVat', align: 'right', sortable: false },
      { text: 'Toplam', value: 'netCash', align: 'right', sortable: false },
      { text: 'Stopaj', value: 'withholding', align: 'right', sortable: false },
      { text: 'Adet Ağırlığı', value: 'unitGram', align: 'right', sortable: false },
      { text: 'Mly', value: 'purity', align: 'right', sortable: false },
      { text: 'T.gramaj', value: 'totalRawGram', align: 'right', sortable: false },
      { text: 'G.gramaj', value: 'totalPureGram', align: 'right', sortable: false },
      { text: 'Satış Has Fiyatı', value: 'salesHasPrice', align: 'right', sortable: false },
      { text: 'Satış Tutarı (Birim)', value: 'netSalesAmount', align: 'right', sortable: false },
      { text: 'İşçilik', value: 'labor', align: 'right', sortable: false },
      { text: 'AF KDV', value: 'laborVat', align: 'right', sortable: false },
      { text: "KDV'li İşçilik", value: 'laborInclVat', align: 'right', sortable: false },
      { text: 'Bağlantı', value: 'link', sortable: false },
      { text: 'Gönderim Durumu', value: 'shippingStatus', sortable: false },
      { text: 'Gönderilen Siparişler', value: 'shippedBarcode', sortable: false },
    ],
    altindafirsatToggleableColumnValues: [
      'commission',
      'commissionVat',
      'commissionWithVat',
      'insurance',
      'insuranceVat',
      'insuranceWithVat',
      'commissionPlusInsurance',
      'commissionVatPlusInsuranceVat',
      'invoiceVat',
    ],
    altindafirsatHiddenColumns: JSON.parse(localStorage.getItem('altindafirsatHiddenColumns') || '[]'),
    refineryUnpaidHeaders: [
      { text: 'Tarih', value: 'agreementDate', sortable: false },
      { text: 'Rafineri', value: 'refineryName', sortable: false },
      { text: 'Has Gram', value: 'pureGram', sortable: false, align: 'right' },
      { text: 'Tutar', value: 'agreedAmount', sortable: false, align: 'right' },
    ],
    refineryOwnedHeaders: [
      { text: 'Rafineri', value: 'refineryName', sortable: false },
      { text: 'Anlaşma', value: 'agreementCount', sortable: false, align: 'center' },
      { text: 'Has Gram', value: 'totalPureGram', sortable: false, align: 'right' },
      { text: 'Girdi', value: 'intake', sortable: false, align: 'center' },
    ],
    intakeDialog: false,
    intakeStep: 1,
    intakeRefinery: null,
    intakeBusy: false,
    intakeResult: null,
    intakeForm: { kind: 0, grams: null, paymentBarcode: '' },
    intakeHistoryDialog: false,
    intakeHistory: [],
    intakeHistoryLoading: false,
    intakeHistoryFilter: { refineryId: null, startDate: null, endDate: null, barcode: '', direction: null },
    intakeStartMenu: false,
    intakeEndMenu: false,
    intakeExpanded: [],
    directionOptions: [{ text: 'Verdik', value: 1 }, { text: 'Aldık', value: 0 }],
    intakeBarcodeTimer: null,
    giveGoldDialog: false,
    giveGoldStep: 1,
    giveGoldBusy: false,
    giveGoldResult: null,
    giveGoldForm: { refineryId: null, kind: 0, grams: null, paymentBarcode: '', notes: '' },
    giveProductRows: [],
    pureGoldAvailable: 0,
    atolyeBarcodeTimer: null,
    intakeHistoryHeaders: [
      { text: 'Tarih', value: 'createdDate', sortable: false, align: 'left' },
      { text: 'Rafineri', value: 'refineryName', sortable: false, align: 'left' },
      { text: 'Tür', value: 'kindText', sortable: false, align: 'center' },
      { text: 'Gram', value: 'grams', sortable: false, align: 'right' },
      { text: 'İşlem Barkodu', value: 'paymentBarcode', sortable: false, align: 'left' },
      { text: 'Rafineri (vardı → oldu)', value: 'refineryOwned', sortable: false, align: 'center' },
      { text: 'Saf Altın Env. (vardı → oldu)', value: 'invPure', sortable: false, align: 'center' },
    ],
    canViewZimmet: false,
    zimmetReconLines: [],
    zimmetDetailDialog: false,
    zimmetDetailUser: null,
    mainVaultDialog: false,
    mainVaultLines: [],
    mainVaultLoading: false,
    fullInventoryDialog: false,
    fullInventoryLoading: false,
    zimmetSummaryHeaders: [
      { text: 'Kullanıcı', value: 'fullName', sortable: false },
      { text: 'Ürün Adedi', value: 'itemCount', sortable: false, align: 'center' },
      { text: 'Toplam Has Gram', value: 'totalHasGram', sortable: false, align: 'right' },
      { text: 'Detay', value: 'detail', sortable: false, align: 'center' },
    ],
    zimmetDetailHeaders: [
      { text: 'Tip', value: 'inventoryTypeName', sortable: false },
      { text: 'Ürün', value: 'productName', sortable: false },
      { text: 'Seri No', value: 'serialNumber', sortable: false },
      { text: 'Adet', value: 'quantity', sortable: false, align: 'center' },
      { text: 'Has Gram', value: 'hasGram', sortable: false, align: 'right' },
      { text: 'Durum', value: 'statusName', sortable: false },
    ],
    fullInventoryHeaders: [
      { text: 'Tip', value: 'inventoryTypeName', sortable: false },
      { text: 'Ürün', value: 'productName', sortable: false },
      { text: 'Ayar', value: 'purityLabel', sortable: false, align: 'center' },
      { text: 'Adet', value: 'quantity', sortable: false, align: 'center' },
      { text: 'Has Gram', value: 'totalHas', sortable: false, align: 'right' },
    ],
    canViewAtolye: false,
    atolyeBalances: [],
    atolyeBalanceHeaders: [
      { text: 'Atölye', value: 'name', sortable: false, align: 'left' },
      { text: 'Bakiye (Has Gram)', value: 'balance', sortable: false, align: 'right' },
      { text: 'İşlem', value: 'actions', sortable: false, align: 'center' },
    ],
    sendGoldDialog: false,
    sendGoldStep: 1,
    sendGoldBusy: false,
    sendGoldResult: null,
    sendGoldForm: { atolyeId: null, kind: 0, grams: null, paymentBarcode: '', notes: '' },
    sendProductRows: [],
    intakeProductRows: [],
    intakeSelectedType: 0,
    sendProductHeaders: [
      { text: 'Ürün', value: 'productName', sortable: false, align: 'left' },
      { text: 'Tip', value: 'inventoryTypeName', sortable: false, align: 'center' },
      { text: 'Boşta', value: 'available', sortable: false, align: 'right' },
      { text: 'Birim Has', value: 'hasPerUnit', sortable: false, align: 'right' },
      { text: 'Adet', value: 'qty', sortable: false, align: 'center' },
    ],
    receiveProductDialog: false,
    receiveAtolye: null,
    receiveBusy: false,
    receiveForm: { grams: null, paymentBarcode: '', notes: '' },
    atolyeHistoryDialog: false,
    atolyeHistory: [],
    atolyeHistoryLoading: false,
    atolyeExpanded: [],
    atolyeHistoryFilter: { atolyeId: null, startDate: null, endDate: null, barcode: '' },
    atolyeStartMenu: false,
    atolyeEndMenu: false,
    atolyeHistoryHeaders: [
      { text: 'Tarih', value: 'createdDate', sortable: false, align: 'left' },
      { text: 'Atölye', value: 'atolyeName', sortable: false, align: 'left' },
      { text: 'Tür', value: 'typeText', sortable: false, align: 'center' },
      { text: 'Gram', value: 'grams', sortable: false, align: 'right' },
      { text: 'İşlem Barkodu', value: 'paymentBarcode', sortable: false, align: 'left' },
      { text: 'Bakiye (vardı → oldu)', value: 'balance', sortable: false, align: 'center' },
      { text: 'Not', value: 'notes', sortable: false, align: 'left' },
    ],
  };
  },
  computed: {
    canViewRefinery() {
      return this.$store.getters['refineries/canViewRefinery'];
    },
    refineryReconciliation() {
      return this.$store.getters['refineries/reconciliation'];
    },
    intakeRefineryOptions() {
      const list = (this.refineryReconciliation.ownedGoldByRefinery || [])
        .filter((r) => r.refineryId > 0)
        .map((r) => ({ id: r.refineryId, name: r.refineryName }));
      const seen = {};
      return list.filter((r) => (seen[r.id] ? false : (seen[r.id] = true)));
    },
    intakeHistoryTotalGrams() {
      return (this.intakeHistory || []).reduce((s, i) => s + (Number(i.grams) || 0), 0);
    },
    filteredIntakeHistory() {
      const dir = this.intakeHistoryFilter.direction;
      if (dir === null || dir === undefined) return this.intakeHistory || [];
      return (this.intakeHistory || []).filter((x) => x.direction === dir);
    },
    giveRefineryOptions() {
      return this.intakeRefineryOptions;
    },
    giveGoldRefineryName() {
      const r = (this.giveRefineryOptions || []).find((x) => x.id === this.giveGoldForm.refineryId);
      return r ? r.name : '';
    },
    giveProductTotalGram() {
      return (this.giveProductRows || []).reduce((s, r) => s + ((Number(r.qty) || 0) * (Number(r.hasPerUnit) || 0)), 0);
    },
    giveGoldEffectiveGram() {
      return this.giveGoldForm.kind === 0 ? (Number(this.giveGoldForm.grams) || 0) : this.giveProductTotalGram;
    },
    giveGoldValid() {
      if (!this.giveGoldForm.refineryId) return false;
      if (this.giveGoldForm.kind === 0) return Number(this.giveGoldForm.grams) > 0 && Number(this.giveGoldForm.grams) <= this.pureGoldAvailable;
      return this.giveProductRows.some((r) => Number(r.qty) > 0);
    },
    atolyeler() {
      return this.$store.getters['atolye/atolyeler'];
    },
    atolyeTotalBalance() {
      return (this.atolyeBalances || []).reduce((s, a) => s + (Number(a.balance) || 0), 0);
    },
    intakeValid() {
      if (this.intakeForm.kind === 1) return this.intakeProductRows.some((r) => Number(r.qty) > 0);
      if (!(Number(this.intakeForm.grams) > 0)) return false;
      if (this.intakeForm.kind === 2 && !this.intakeForm.atolyeId) return false;
      return true;
    },
    intakeVisibleRows() {
      return (this.intakeProductRows || []).filter((r) => r.inventoryType === this.intakeSelectedType);
    },
    intakeSelectedItems() {
      return (this.intakeProductRows || []).filter((r) => Number(r.qty) > 0);
    },
    intakeProductTotalGram() {
      return (this.intakeProductRows || []).reduce((s, r) => s + ((Number(r.qty) || 0) * (Number(r.hasPerUnit) || 0)), 0);
    },
    intakeEffectiveGram() {
      return this.intakeForm.kind === 1 ? this.intakeProductTotalGram : (Number(this.intakeForm.grams) || 0);
    },
    intakeAtolyeName() {
      const a = (this.atolyeler || []).find((x) => x.id === this.intakeForm.atolyeId);
      return a ? a.name : '';
    },
    sendGoldAtolyeName() {
      const a = (this.atolyeler || []).find((x) => x.id === this.sendGoldForm.atolyeId);
      return a ? a.name : '';
    },
    sendProductTotalGram() {
      return (this.sendProductRows || []).reduce((s, r) => s + ((Number(r.qty) || 0) * (Number(r.hasPerUnit) || 0)), 0);
    },
    sendGoldEffectiveGram() {
      return this.sendGoldForm.kind === 0 ? (Number(this.sendGoldForm.grams) || 0) : this.sendProductTotalGram;
    },
    sendGoldValid() {
      if (!this.sendGoldForm.atolyeId) return false;
      if (this.sendGoldForm.kind === 0) return Number(this.sendGoldForm.grams) > 0 && Number(this.sendGoldForm.grams) <= this.pureGoldAvailable;
      return this.sendProductRows.some((r) => Number(r.qty) > 0);
    },
    zimmetSummary() {
      const byUser = {};
      (this.zimmetReconLines || []).forEach((l) => {
        const key = l.userId;
        if (!byUser[key]) {
          byUser[key] = {
            userId: l.userId,
            fullName: ((l.firstName || '') + ' ' + (l.lastName || '')).trim() || l.userName || ('#' + l.userId),
            itemCount: 0,
            totalHasGram: 0,
          };
        }
        byUser[key].itemCount += Number(l.quantity) || 0;
        byUser[key].totalHasGram += Number(l.hasGram) || 0;
      });
      return Object.values(byUser).sort((a, b) => b.totalHasGram - a.totalHasGram);
    },
    zimmetTotalHasGram() {
      return (this.zimmetReconLines || []).reduce((s, l) => s + (Number(l.hasGram) || 0), 0);
    },
    zimmetDetailLines() {
      if (!this.zimmetDetailUser) return [];
      return (this.zimmetReconLines || []).filter((l) => l.userId === this.zimmetDetailUser.userId);
    },
    mainVaultTotalHas() {
      return (this.mainVaultLines || []).reduce((s, l) => s + (Number(l.hasGram) || 0), 0);
    },
    fullInventoryItems() {
      const map = {};
      const merge = (lines) => {
        (lines || []).forEach((l) => {
          const isTaki = !!l.jewelryItemId || Number(l.inventoryType) === 0;
          const key = isTaki
            ? `T|${l.productName}|${l.purity}|${l.size || ''}`
            : `I|${l.inventoryItemId}`;
          if (!map[key]) {
            map[key] = {
              inventoryType: l.inventoryType,
              inventoryTypeName: l.inventoryTypeName,
              productName: l.productName,
              purityLabel: l.purityLabel,
              purity: l.purity,
              quantity: 0,
              hasGram: 0,
            };
          }
          map[key].quantity += Number(l.quantity) || 0;
          map[key].hasGram += Number(l.hasGram) || 0;
        });
      };
      merge(this.mainVaultLines);
      merge(this.zimmetReconLines);
      return Object.values(map)
        .filter((x) => x.quantity !== 0 || x.hasGram !== 0)
        .sort((a, b) => (a.inventoryType - b.inventoryType) || a.productName.localeCompare(b.productName, 'tr'));
    },
    fullInventoryTotalHas() {
      return (this.fullInventoryItems || []).reduce((s, l) => s + (Number(l.hasGram) || 0), 0);
    },
    goldSentTableItems() {
      return [
        { label: 'Toplam Gönderilen Altın (GR)', value: this.formatGold(this.goldSentData.totalGoldSent) },
        { label: 'Toplam Ödeme (TL)', value: (this.goldSentData.totalPayment || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺' }
      ];
    },
    tenantId() {
      const savedTenantId = localStorage.getItem('selectedTenantId');
      return savedTenantId ? parseInt(savedTenantId) : 0;
    },
    mpId() {
      const savedMpId = localStorage.getItem('selectedMpId');
      return savedMpId ? parseInt(savedMpId) : 0;
    },
    isYurticiKargoFlow() {
      return this.tenantId === 1 && this.mpId === 5;
    },
    completedOrdersTotalCurrentGold() {
      return (this.completedOrdersSummary || []).reduce((sum, row) => sum + (Number(row.currentGoldAmount) || 0), 0);
    },
    completedOrdersTotalGold() {
      return (this.completedOrdersSummary || []).reduce((sum, row) => sum + (Number(row.totalGoldAmount) || 0), 0);
    },
    ealtinOrderControlCityOptions() {
      const list = this.ealtinOrderControlList || [];
      const set = new Set();
      list.forEach((row) => {
        if (row.shippingCity) set.add(row.shippingCity);
      });
      return Array.from(set).sort((a, b) => a.localeCompare(b, 'tr'));
    },
    filteredEaltinOrderControlList() {
      const list = this.ealtinOrderControlList || [];
      const cities = (this.selectedEaltinOrderControlCities || []).filter((c) => !!c);
      if (cities.length === 0) return list;
      const set = new Set(cities);
      return list.filter((row) => row.shippingCity && set.has(row.shippingCity));
    },
    ealtinOrderControlTotalExpectedSum() {
      const list = this.filteredEaltinOrderControlList || [];
      return list.reduce((sum, row) => sum + (Number(row.totalExpected) || 0), 0);
    },
    ealtinOrderControlTotalWithNewOrders() {
      return this.ealtinOrderControlTotalExpectedSum + (Number(this.ealtinNewOrdersExpectedTotal) || 0);
    },
    altindafirsatOrderControlTotalWithNewOrders() {
      return (Number(this.altindafirsatTotals.netCash) || 0) + (Number(this.altindafirsatNewOrdersExpectedTotal) || 0);
    },
    ealtinOrderControlTotals() {
      const list = this.filteredEaltinOrderControlList || [];
      return list.reduce(
        (acc, row) => {
          acc.totalVat += Number(row.totalVat) || 0;
          acc.commissionVat += Number(row.commissionVat) || 0;
          acc.withholding += Number(row.withholding) || 0;
          acc.labor += Number(row.labor) || 0;
          acc.commission += Number(row.commission) || 0;
          acc.commissionWithVat += Number(row.commissionWithVat) || 0;
          acc.serviceFee += Number(row.serviceFee) || 0;
          return acc;
        },
        { totalVat: 0, commissionVat: 0, withholding: 0, labor: 0, commission: 0, commissionWithVat: 0, serviceFee: 0 }
      );
    },
    ealtinOrderControlAverages() {
      const list = this.filteredEaltinOrderControlList || [];
      const acc = list.reduce(
        (a, row) => {
          const weight =
            (Number(row.totalGramWeight) || 0) ||
            (Number(row.grams) || 0) ||
            0;
          const hasPrice = Number(row.hasPrice) || 0;
          const salesAmount = Number(row.salesAmount) || 0;

          a.weightSum += weight;
          a.hasWeightedSum += hasPrice * weight;
          a.salesWeightedSum += salesAmount * weight;
          return a;
        },
        { weightSum: 0, hasWeightedSum: 0, salesWeightedSum: 0 }
      );

      const avgHasPrice = acc.weightSum ? acc.hasWeightedSum / acc.weightSum : 0;
      const avgSalesPrice = acc.weightSum ? acc.salesWeightedSum / acc.weightSum : 0;

      return { avgHasPrice, avgSalesPrice };
    },
    altindafirsatOrderControlCityOptions() {
      const list = this.altindafirsatOrderControlList || [];
      const set = new Set();
      list.forEach((row) => {
        if (row.shippingCity) set.add(row.shippingCity);
      });
      return Array.from(set).sort((a, b) => a.localeCompare(b, 'tr'));
    },
    filteredAltindafirsatOrderControlList() {
      const list = this.altindafirsatOrderControlList || [];
      const cities = (this.selectedAltindafirsatOrderControlCities || []).filter((c) => !!c);
      if (cities.length === 0) return list;
      const set = new Set(cities);
      return list.filter((row) => row.shippingCity && set.has(row.shippingCity));
    },
    altindafirsatTotals() {
      const list = this.filteredAltindafirsatOrderControlList || [];
      return list.reduce(
        (acc, row) => {
          acc.invoiceAmount += Number(row.invoiceAmount) || 0;
          acc.commission += Number(row.commission) || 0;
          acc.commissionWithVat += Number(row.commissionWithVat) || 0;
          acc.insurance += Number(row.insurance) || 0;
          acc.insuranceWithVat += Number(row.insuranceWithVat) || 0;
          acc.labor += Number(row.labor) || 0;
          acc.laborInclVat += Number(row.laborInclVat) || 0;
          acc.withholding += Number(row.withholding) || 0;
          acc.invoiceVat += Number(row.invoiceVat) || 0;
          acc.netCash += Number(row.netCash) || 0;
          acc.netSalesAmount += Number(row.netSalesAmount) || 0;
          acc.totalPureGram += Number(row.totalPureGram) || 0;
          return acc;
        },
        {
          invoiceAmount: 0, commission: 0, commissionWithVat: 0,
          insurance: 0, insuranceWithVat: 0, labor: 0, laborInclVat: 0,
          withholding: 0, invoiceVat: 0, netCash: 0, netSalesAmount: 0,
          totalPureGram: 0
        }
      );
    },
    altindafirsatToggleableColumns() {
      const set = new Set(this.altindafirsatToggleableColumnValues);
      return this.altindafirsatOrderControlHeaders.filter((h) => set.has(h.value));
    },
    altindafirsatVisibleHeaders() {
      return this.altindafirsatOrderControlHeaders.filter(
        (h) => !this.altindafirsatHiddenColumns.includes(h.value)
      );
    }
  },
  methods: {
    isAltindafirsatColumnVisible(value) {
      return !this.altindafirsatHiddenColumns.includes(value);
    },
    toggleAltindafirsatColumn(value) {
      const idx = this.altindafirsatHiddenColumns.indexOf(value);
      if (idx >= 0) {
        this.altindafirsatHiddenColumns.splice(idx, 1);
      } else {
        this.altindafirsatHiddenColumns.push(value);
      }
      localStorage.setItem(
        'altindafirsatHiddenColumns',
        JSON.stringify(this.altindafirsatHiddenColumns)
      );
    },
    toggleAllAltindafirsatColumns() {
      if (this.altindafirsatHiddenColumns.length === 0) {
        this.altindafirsatHiddenColumns = this.altindafirsatToggleableColumnValues.slice();
      } else {
        this.altindafirsatHiddenColumns = [];
      }
      localStorage.setItem(
        'altindafirsatHiddenColumns',
        JSON.stringify(this.altindafirsatHiddenColumns)
      );
    },
    getDate(day) {
      return new Date()
        .addDays(day)
        .toISOString()
        .substr(0, 10);
    },
    async initialize() {
      const today = new Date().toISOString().substr(0, 10);
      await Promise.all([
        this.$store.dispatch("reports/getOrderReports", {
          startDate: today,
          endDate: today,
        }),
        this.$store.dispatch("reports/getBestSellingProductsReports", {
          startDate: today,
          endDate: today,
        }),
        Api.get(
          `api/reports/GetOrderUyumStateReports?startDate=${this.getDate(
            -30
          )}&endDate=${this.getDate(+1)}`
        ).then((r) => { this.uyumMonthly = r.data; }),
        Api.get(
          `api/reports/GetOrderUyumStateReports?startDate=${this.getDate(
            0
          )}&endDate=${this.getDate(+1)}`
        ).then((r) => { this.uyumDaily = r.data; }),
        Api.get(
          `api/reports/GetOrderReports?startDate=${this.getDate(
            -30
          )}&endDate=${this.getDate(+1)}`
        ).then((r) => { this.orderMonthly = r.data; }),
        Api.get(
          `api/reports/getBestSellingProductsReports?startDate=${this.getDate(
            -30
          )}&endDate=${this.getDate(+1)}`
        ).then((r) => { this.productMonthly = r.data; }),
        Api.get(
          `api/reports/getHasAverage?startDate=${this.getDate(
            0
          )}&endDate=${this.getDate(+1)}`
        ).then((r) => { this.hasAverage = r.data; }),
        this.loadTotalGoldSentBetweenDates(),
      ]);
    },
    async loadTotalGoldSentBetweenDates() {
      this.goldSentLoading = true;
      try {
        const res = await Api.get(
          `api/orders/GetTotalGoldSentBetweenDates?startDate=${this.goldSentStartDate}&endDate=${this.goldSentEndDate}`
        );
        this.goldSentData = res.data || { totalGoldSent: 0, totalPayment: 0 };
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Gönderilen altın özeti yüklenirken hata:', err);
        this.goldSentData = { totalGoldSent: 0, totalPayment: 0 };
      } finally {
        this.goldSentLoading = false;
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async loadNewOrdersSummary() {
      this.newOrdersLoading = true;
      try {
        const data = await this.$store.dispatch('richOrders/getNewOrdersBankSummary', {
          startDate: this.newOrdersStartDate,
          endDate: this.newOrdersEndDate
        });
        this.newOrdersSummary = data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Yeni siparişler özeti yüklenirken hata:', error);
      } finally {
        this.newOrdersLoading = false;
      }
    },
    async loadCompletedOrdersSummary() {
      this.completedOrdersLoading = true;
      try {
        const data = await this.$store.dispatch('richOrders/getCompletedOrdersBankSummary', {
          date: this.completedOrdersDate
        });
        this.completedOrdersSummary = data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Tamamlanan siparişler özeti yüklenirken hata:', error);
      } finally {
        this.completedOrdersLoading = false;
      }
    },
    async loadEaltinOrderControl() {
      this.ealtinOrderControlLoading = true;
      try {
        const data = await this.$store.dispatch('richOrders/getEaltinOrderListExcel', {
          date: this.ealtinOrderControlDate
        });
        this.ealtinOrderControlList = data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Gün bazında sipariş kontrol listesi yüklenirken hata:', error);
      } finally {
        this.ealtinOrderControlLoading = false;
      }
      try {
        const total = await this.$store.dispatch('richOrders/getEaltinNewOrdersExpectedTotal');
        this.ealtinNewOrdersExpectedTotal = Number(total) || 0;
      } catch (error) {
        this.ealtinNewOrdersExpectedTotal = 0;
      }
    },
    async loadAltindafirsatOrderControl() {
      this.altindafirsatOrderControlLoading = true;
      try {
        const data = await this.$store.dispatch('richOrders/getAltindafirsatOrderListExcel', {
          date: this.altindafirsatOrderControlDate
        });
        this.altindafirsatOrderControlList = data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Altındafırsat gün bazında sipariş kontrol listesi yüklenirken hata:', error);
      } finally {
        this.altindafirsatOrderControlLoading = false;
      }
      try {
        const total = await this.$store.dispatch('richOrders/getAltindafirsatNewOrdersExpectedTotal');
        this.altindafirsatNewOrdersExpectedTotal = Number(total) || 0;
      } catch (error) {
        this.altindafirsatNewOrdersExpectedTotal = 0;
      }
    },
    focusBarcodeInput() {
      this.$nextTick(() => {
        setTimeout(() => {
          const ref = this.$refs.barcodeInputRef;
          if (!ref) return;
          if (typeof ref.focus === 'function') {
            ref.focus();
            return;
          }
          if (ref.$el) {
            const input = ref.$el.querySelector('input');
            if (input) input.focus();
          }
        }, 100);
      });
    },
    onBarcodeInputBlur() {
      if (!this.barcodeDialogOpen) return;
      if (this.barcodeConfirming) return;
      this.focusBarcodeInput();
    },
    openBarcodeDialog() {
      this.barcodeInput = '';
      this.scannedBarcodes = [];
      this.barcodeConfirmResult = null;
      this.duplicateBarcodeWarning = null;
      this.duplicateFlashIdx = null;
      this.barcodeDialogOpen = true;
      this.focusBarcodeInput();
    },
    closeBarcodeDialog() {
      const hadConfirmed = !!(this.barcodeConfirmResult && this.barcodeConfirmResult.confirmed && this.barcodeConfirmResult.confirmed.length);
      this.barcodeDialogOpen = false;
      this.barcodeInput = '';
      this.scannedBarcodes = [];
      this.barcodeConfirmResult = null;
      this.duplicateBarcodeWarning = null;
      this.duplicateFlashIdx = null;
      if (this.duplicateFlashTimer) clearTimeout(this.duplicateFlashTimer);
      if (hadConfirmed) {
        this.loadAltindafirsatOrderControl();
        this.refreshMintSummary();
      }
    },
    refreshMintSummary() {
      const card = this.$refs.mintSummaryCard;
      if (card && typeof card.loadPlan === 'function') {
        card.loadPlan();
      }
    },
    addBarcode() {
      const value = (this.barcodeInput || '').trim();
      if (!value) {
        this.barcodeInput = '';
        return;
      }
      const existingIdx = this.scannedBarcodes.indexOf(value);
      if (existingIdx !== -1) {
        this.flashDuplicateBarcode(value, existingIdx);
      } else {
        this.scannedBarcodes.push(value);
        this.duplicateBarcodeWarning = null;
      }
      this.barcodeInput = '';
      this.focusBarcodeInput();
    },
    flashDuplicateBarcode(value, idx) {
      this.duplicateBarcodeWarning = value;
      this.duplicateFlashIdx = idx;
      if (this.duplicateFlashTimer) clearTimeout(this.duplicateFlashTimer);
      this.duplicateFlashTimer = setTimeout(() => {
        this.duplicateFlashIdx = null;
      }, 1800);
      this.playDuplicateBeep();
    },
    playDuplicateBeep() {
      try {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return;
        const ctx = new AudioCtx();
        const now = ctx.currentTime;
        const beep = (start, freq) => {
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.type = 'square';
          osc.frequency.value = freq;
          gain.gain.setValueAtTime(0.0001, start);
          gain.gain.exponentialRampToValueAtTime(0.2, start + 0.01);
          gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.12);
          osc.connect(gain);
          gain.connect(ctx.destination);
          osc.start(start);
          osc.stop(start + 0.14);
        };
        beep(now, 880);
        beep(now + 0.16, 660);
        setTimeout(() => {
          try { ctx.close(); } catch (e) { /* yut */ }
        }, 500);
      } catch (e) {
        /* yut */
      }
    },
    removeBarcode(idx) {
      this.scannedBarcodes.splice(idx, 1);
      this.duplicateBarcodeWarning = null;
      this.duplicateFlashIdx = null;
    },
    clearBarcodes() {
      this.scannedBarcodes = [];
      this.barcodeConfirmResult = null;
      this.duplicateBarcodeWarning = null;
      this.duplicateFlashIdx = null;
    },
    async confirmBarcodes() {
      if (!this.scannedBarcodes.length) return;
      this.barcodeConfirming = true;
      this.barcodeConfirmResult = null;
      try {
        const { data } = await orders.bulkConfirmBarcode(this.scannedBarcodes);
        this.barcodeConfirmResult = data || { confirmed: [], alreadyConfirmed: [], notFound: [], notShipped: [] };
        this.scannedBarcodes = [];
        if (this.barcodeConfirmResult.confirmed && this.barcodeConfirmResult.confirmed.length) {
          this.loadAltindafirsatOrderControl();
          this.refreshMintSummary();
        }

        if (this.isYurticiKargoFlow &&
            this.barcodeConfirmResult.confirmed &&
            this.barcodeConfirmResult.confirmed.length) {
          await this.sendConfirmedToYurticiKargo(this.barcodeConfirmResult.confirmed);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Barkod onaylama sırasında hata:', error);
      } finally {
        this.barcodeConfirming = false;
      }
    },
    async sendConfirmedToYurticiKargo(barcodes) {
      const tasks = barcodes.map(b =>
        yurticiKargoApi.sendOrderByBarcode({ barcode: b, paymentType: 0 })
          .then(r => ({ barcode: b, data: r.data }))
          .catch(e => ({ barcode: b, error: (e.response && e.response.data && e.response.data.error) || e.message }))
      );
      const results = await Promise.all(tasks);

      const ykSuccess = [];
      const ykFailed = [];
      results.forEach(r => {
        if (r.error) {
          ykFailed.push({ barcode: r.barcode, error: r.error });
        } else if (r.data && r.data.success) {
          ykSuccess.push(r.barcode);
        } else {
          ykFailed.push({ barcode: r.barcode, error: (r.data && r.data.error) || 'Bilinmeyen hata' });
        }
      });

      this.$set(this.barcodeConfirmResult, 'ykSuccess', ykSuccess);
      this.$set(this.barcodeConfirmResult, 'ykFailed', ykFailed);
    },
    formatDateTime(value) {
      if (!value) return '';
      const d = new Date(value);
      return d.toLocaleDateString('tr-TR') + ' ' +
        d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    },
    formatGold(value) {
      if (value === null || value === undefined) return '0.00 GR';
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value) + ' GR';
    },
    formatNumber(value, digits = 2) {
      if (value === null || value === undefined) return '';
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(value);
    },
    formatGramTruncate(value) {
      if (value === null || value === undefined) return '';
      const num = Number(value);
      if (!isFinite(num)) return '';
      const fixed = num.toFixed(10);
      const [intPart, decPartRaw] = fixed.split('.');
      const decPart = (decPartRaw || '').slice(0, 2).padEnd(2, '0');
      const truncated = parseFloat(intPart + '.' + decPart);
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(truncated);
    },
    formatDateOnly(value) {
      if (!value) return '';
      return new Date(value).toLocaleDateString('tr-TR');
    },
    formatGram(value) {
      return (Number(value) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' gr';
    },
    formatDiff(value) {
      const n = Number(value) || 0;
      if (Math.abs(n) < 0.00005) return '—';
      return (n > 0 ? '+' : '−') + this.formatGram(Math.abs(n));
    },
    diffStyle(value) {
      const n = Number(value) || 0;
      if (Math.abs(n) < 0.00005) return 'color:#94a3b8';
      return n > 0 ? 'color:#059669' : 'color:#dc2626';
    },
    async loadRefineryReconciliation() {
      const can = await this.$store.dispatch('refineries/getCanView');
      if (can) {
        await this.$store.dispatch('refineries/getReconciliation');
        await this.$store.dispatch('atolye/getAtolyeler');
      }
    },
    async loadZimmetSection() {
      try {
        this.canViewZimmet = !!(await this.$store.dispatch('inventory/getZimmetCanView'));
        if (this.canViewZimmet) {
          await this.loadZimmetReconciliation();
        }
      } catch (e) {
        this.canViewZimmet = false;
      }
    },
    async loadZimmetReconciliation() {
      try {
        this.zimmetReconLines = (await this.$store.dispatch('inventory/getZimmetReconciliation')) || [];
      } catch (e) {
        this.zimmetReconLines = [];
      }
    },
    openZimmetDetail(user) {
      this.zimmetDetailUser = user;
      this.zimmetDetailDialog = true;
    },
    openIntake(refinery) {
      this.intakeRefinery = refinery;
      this.intakeForm = { kind: 0, grams: null, paymentBarcode: '', notes: '', atolyeId: null };
      this.intakeStep = 1;
      this.intakeResult = null;
      this.intakeBusy = false;
      this.intakeProductRows = [];
      this.intakeSelectedType = 0;
      this.intakeDialog = true;
      this.loadIntakeProducts();
    },
    async loadIntakeProducts() {
      try {
        const kasa = (await this.$store.dispatch('inventory/getKasa')) || [];
        this.intakeProductRows = kasa
          .filter((k) => Number(k.quantity) > 0 && (k.inventoryItemId || k.jewelryItemId))
          .map((k) => ({
            rowKey: k.inventoryType + '-' + (k.inventoryItemId || ('j' + k.jewelryItemId)),
            inventoryItemId: k.inventoryItemId || null,
            inventoryType: k.inventoryType,
            productName: k.productName,
            inventoryTypeName: k.inventoryTypeName,
            available: Number(k.quantity) || 0,
            hasPerUnit: Number(k.quantity) > 0 ? (Number(k.hasGram) || 0) / Number(k.quantity) : 0,
            qty: 0,
          }));
      } catch (e) {
        this.intakeProductRows = [];
      }
    },
    async confirmIntake() {
      this.intakeBusy = true;
      try {
        const isProduct = this.intakeForm.kind === 1;
        const items = isProduct
          ? this.intakeProductRows
              .filter((r) => Number(r.qty) > 0)
              .map((r) => ({
                inventoryItemId: r.inventoryItemId,
                productName: r.productName,
                quantity: Number(r.qty) || 0,
                hasPerUnit: Number(r.hasPerUnit) || 0,
              }))
          : [];
        const result = await this.$store.dispatch('refineries/recordIntake', {
          refineryId: this.intakeRefinery.refineryId,
          kind: this.intakeForm.kind,
          grams: isProduct ? this.intakeProductTotalGram : (Number(this.intakeForm.grams) || 0),
          paymentBarcode: this.intakeForm.paymentBarcode ? this.intakeForm.paymentBarcode.trim() : null,
          notes: this.intakeForm.notes ? this.intakeForm.notes.trim() : null,
          atolyeId: this.intakeForm.kind === 2 ? this.intakeForm.atolyeId : null,
          items,
        });
        this.intakeResult = result;
        this.intakeStep = 3;
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || 'Girdi kaydedilemedi.';
        this.$store.state.dialog = true;
        this.$store.state.message = msg;
      } finally {
        this.intakeBusy = false;
      }
    },
    async finishIntake() {
      this.intakeDialog = false;
      await this.$store.dispatch('refineries/getReconciliation');
      if (this.canViewAtolye) await this.loadAtolyeBalances();
    },
    openIntakeHistory() {
      const today = new Date();
      const weekAgo = new Date();
      weekAgo.setDate(today.getDate() - 7);
      this.intakeHistoryFilter = {
        refineryId: null,
        startDate: weekAgo.toISOString().substr(0, 10),
        endDate: today.toISOString().substr(0, 10),
        barcode: '',
        direction: null,
      };
      this.intakeHistoryDialog = true;
      this.loadIntakeHistory();
    },
    async loadIntakeHistory() {
      this.intakeHistoryLoading = true;
      this.intakeExpanded = [];
      try {
        this.intakeHistory = (await this.$store.dispatch('refineries/getHistory', {
          refineryId: this.intakeHistoryFilter.refineryId || null,
          startDate: this.intakeHistoryFilter.startDate || null,
          endDate: this.intakeHistoryFilter.endDate || null,
          barcode: this.intakeHistoryFilter.barcode || null,
        })) || [];
      } catch (e) {
        this.intakeHistory = [];
      } finally {
        this.intakeHistoryLoading = false;
      }
    },
    onIntakeBarcodeSearch() {
      if (this.intakeBarcodeTimer) clearTimeout(this.intakeBarcodeTimer);
      this.intakeBarcodeTimer = setTimeout(() => this.loadIntakeHistory(), 350);
    },
    toggleIntakeRow(i) {
      const idx = this.intakeExpanded.indexOf(i);
      if (idx >= 0) this.intakeExpanded.splice(idx, 1);
      else this.intakeExpanded.push(i);
    },
    async openGiveGold() {
      if (!this.atolyeler || this.intakeRefineryOptions.length === 0) {
        await this.$store.dispatch('refineries/getReconciliation');
      }
      this.giveGoldForm = { refineryId: null, kind: 0, grams: null, paymentBarcode: '', notes: '' };
      this.giveGoldStep = 1;
      this.giveGoldResult = null;
      this.giveGoldBusy = false;
      this.giveProductRows = [];
      this.pureGoldAvailable = 0;
      this.giveGoldDialog = true;
      try {
        const kasa = (await this.$store.dispatch('inventory/getKasa')) || [];
        this.pureGoldAvailable = this.extractPureGold(kasa);
        this.giveProductRows = kasa
          .filter((k) => (k.inventoryType === 1 || k.inventoryType === 2) && k.inventoryItemId && Number(k.quantity) > 0)
          .map((k) => ({
            inventoryItemId: k.inventoryItemId,
            productName: k.productName,
            inventoryTypeName: k.inventoryTypeName,
            available: Number(k.quantity) || 0,
            hasPerUnit: Number(k.quantity) > 0 ? (Number(k.hasGram) || 0) / Number(k.quantity) : 0,
            qty: 0,
          }));
      } catch (e) {
        this.giveProductRows = [];
      }
    },
    async confirmGiveGold() {
      this.giveGoldBusy = true;
      try {
        const payload = {
          refineryId: this.giveGoldForm.refineryId,
          kind: this.giveGoldForm.kind,
          grams: Number(this.giveGoldForm.grams) || 0,
          paymentBarcode: this.giveGoldForm.paymentBarcode ? this.giveGoldForm.paymentBarcode.trim() : null,
          notes: this.giveGoldForm.notes ? this.giveGoldForm.notes.trim() : null,
          items: this.giveGoldForm.kind === 1
            ? this.giveProductRows.filter((r) => Number(r.qty) > 0).map((r) => ({ inventoryItemId: r.inventoryItemId, quantity: Number(r.qty) }))
            : [],
        };
        this.giveGoldResult = await this.$store.dispatch('refineries/giveGold', payload);
        this.giveGoldStep = 3;
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || 'Gönderim başarısız.';
        this.$store.state.dialog = true;
        this.$store.state.message = msg;
      } finally {
        this.giveGoldBusy = false;
      }
    },
    async finishGiveGold() {
      this.giveGoldDialog = false;
      await this.$store.dispatch('refineries/getReconciliation');
    },
    async openMainVault() {
      this.mainVaultDialog = true;
      this.mainVaultLoading = true;
      try {
        this.mainVaultLines = (await this.$store.dispatch('inventory/getKasa')) || [];
      } catch (e) {
        this.mainVaultLines = [];
      } finally {
        this.mainVaultLoading = false;
      }
    },
    async openFullInventory() {
      this.fullInventoryDialog = true;
      this.fullInventoryLoading = true;
      try {
        const tasks = [this.$store.dispatch('inventory/getKasa')];
        if (!this.zimmetReconLines || this.zimmetReconLines.length === 0) {
          tasks.push(this.$store.dispatch('inventory/getZimmetReconciliation'));
        }
        const [kasa, zimmet] = await Promise.all(tasks);
        this.mainVaultLines = kasa || [];
        if (zimmet) this.zimmetReconLines = zimmet || [];
      } catch (e) {
        this.mainVaultLines = [];
      } finally {
        this.fullInventoryLoading = false;
      }
    },
    async loadAtolyeSection() {
      try {
        this.canViewAtolye = !!(await this.$store.dispatch('atolye/getCanView'));
        if (this.canViewAtolye) {
          await Promise.all([
            this.$store.dispatch('atolye/getAtolyeler'),
            this.loadAtolyeBalances(),
          ]);
        }
      } catch (e) {
        this.canViewAtolye = false;
      }
    },
    async loadAtolyeBalances() {
      try {
        this.atolyeBalances = (await this.$store.dispatch('atolye/getBalances')) || [];
      } catch (e) {
        this.atolyeBalances = [];
      }
    },
    async openSendGold() {
      if (!this.atolyeler || this.atolyeler.length === 0) {
        await this.$store.dispatch('atolye/getAtolyeler');
      }
      this.sendGoldForm = { atolyeId: null, kind: 0, grams: null, paymentBarcode: '', notes: '' };
      this.sendGoldStep = 1;
      this.sendGoldResult = null;
      this.sendGoldBusy = false;
      this.sendProductRows = [];
      this.pureGoldAvailable = 0;
      this.sendGoldDialog = true;
      try {
        const kasa = (await this.$store.dispatch('inventory/getKasa')) || [];
        this.pureGoldAvailable = this.extractPureGold(kasa);
        this.sendProductRows = kasa
          .filter((k) => (k.inventoryType === 1 || k.inventoryType === 2) && k.inventoryItemId && Number(k.quantity) > 0)
          .map((k) => ({
            inventoryItemId: k.inventoryItemId,
            productName: k.productName,
            inventoryTypeName: k.inventoryTypeName,
            available: Number(k.quantity) || 0,
            hasPerUnit: Number(k.quantity) > 0 ? (Number(k.hasGram) || 0) / Number(k.quantity) : 0,
            qty: 0,
          }));
      } catch (e) {
        this.sendProductRows = [];
      }
    },
    extractPureGold(kasa) {
      const row = (kasa || []).find((k) => k.productName === 'Rafineri Saf Altını' || (k.inventoryType === 3 && (k.systemKey === 'REFINERY_PURE_GOLD')));
      return row ? (Number(row.hasGram) || 0) : 0;
    },
    async confirmSendGold() {
      this.sendGoldBusy = true;
      try {
        const payload = {
          atolyeId: this.sendGoldForm.atolyeId,
          kind: this.sendGoldForm.kind,
          grams: Number(this.sendGoldForm.grams) || 0,
          paymentBarcode: this.sendGoldForm.paymentBarcode ? this.sendGoldForm.paymentBarcode.trim() : null,
          notes: this.sendGoldForm.notes ? this.sendGoldForm.notes.trim() : null,
          items: this.sendGoldForm.kind === 1
            ? this.sendProductRows.filter((r) => Number(r.qty) > 0).map((r) => ({ inventoryItemId: r.inventoryItemId, quantity: Number(r.qty) }))
            : [],
        };
        this.sendGoldResult = await this.$store.dispatch('atolye/sendGold', payload);
        this.sendGoldStep = 3;
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || 'Gönderim başarısız.';
        this.$store.state.dialog = true;
        this.$store.state.message = msg;
      } finally {
        this.sendGoldBusy = false;
      }
    },
    async finishSendGold() {
      this.sendGoldDialog = false;
      await this.loadAtolyeBalances();
    },
    openReceiveProduct(atolye) {
      this.receiveAtolye = atolye;
      this.receiveForm = { grams: null, paymentBarcode: '', notes: '' };
      this.receiveBusy = false;
      this.receiveProductDialog = true;
    },
    async confirmReceiveProduct() {
      this.receiveBusy = true;
      try {
        await this.$store.dispatch('atolye/receiveProduct', {
          atolyeId: this.receiveAtolye.atolyeId,
          grams: Number(this.receiveForm.grams) || 0,
          paymentBarcode: this.receiveForm.paymentBarcode ? this.receiveForm.paymentBarcode.trim() : null,
          notes: this.receiveForm.notes ? this.receiveForm.notes.trim() : null,
        });
        this.receiveProductDialog = false;
        await this.loadAtolyeBalances();
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || 'İşlem başarısız.';
        this.$store.state.dialog = true;
        this.$store.state.message = msg;
      } finally {
        this.receiveBusy = false;
      }
    },
    openAtolyeHistory(atolye) {
      const today = new Date();
      const weekAgo = new Date();
      weekAgo.setDate(today.getDate() - 7);
      this.atolyeHistoryFilter = {
        atolyeId: atolye ? atolye.atolyeId : null,
        startDate: weekAgo.toISOString().substr(0, 10),
        endDate: today.toISOString().substr(0, 10),
        barcode: '',
      };
      this.atolyeHistoryDialog = true;
      this.loadAtolyeHistory();
    },
    async loadAtolyeHistory() {
      this.atolyeHistoryLoading = true;
      this.atolyeExpanded = [];
      try {
        this.atolyeHistory = (await this.$store.dispatch('atolye/getMovements', {
          atolyeId: this.atolyeHistoryFilter.atolyeId || null,
          startDate: this.atolyeHistoryFilter.startDate || null,
          endDate: this.atolyeHistoryFilter.endDate || null,
          barcode: this.atolyeHistoryFilter.barcode || null,
        })) || [];
      } catch (e) {
        this.atolyeHistory = [];
      } finally {
        this.atolyeHistoryLoading = false;
      }
    },
    onAtolyeBarcodeSearch() {
      if (this.atolyeBarcodeTimer) clearTimeout(this.atolyeBarcodeTimer);
      this.atolyeBarcodeTimer = setTimeout(() => this.loadAtolyeHistory(), 350);
    },
    toggleAtolyeRow(i) {
      const idx = this.atolyeExpanded.indexOf(i);
      if (idx >= 0) this.atolyeExpanded.splice(idx, 1);
      else this.atolyeExpanded.push(i);
    },
  },
  async mounted() {
    const tasks = [this.initialize(), this.loadRefineryReconciliation(), this.loadZimmetSection(), this.loadAtolyeSection()];
    if (this.tenantId === 2) {
      tasks.push(
        this.loadNewOrdersSummary(),
        this.loadCompletedOrdersSummary(),
        this.loadEaltinOrderControl()
      );
    }
    if (this.tenantId === 1) {
      tasks.push(this.loadAltindafirsatOrderControl());
    }
    await Promise.all(tasks);
  },
};
</script>

<style scoped>
.fin-card {
  width: 100%;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(15,23,42,0.08);
  overflow: hidden;
  margin-bottom: 20px;
}
.fin-head {
  padding: 14px 24px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #e2e8f0;
}
.fin-head--amber { background: #fef3c7; border-bottom-color: #fde68a; }
.fin-head--grey { background: #f1f5f9; border-bottom-color: #e2e8f0; }
.fin-head--purple { background: #f3e8ff; border-bottom-color: #e9d5ff; }
.fin-head-title { display: flex; align-items: center; gap: 12px; }
.fin-head-icon { font-size: 28px; }
.fin-title { font-size: 20px; font-weight: 600; margin: 0; letter-spacing: -0.01em; }
.fin-head-actions { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
.fin-textbtn {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 14px; font-weight: 500; background: none; border: none;
  cursor: pointer; padding: 0; transition: opacity .15s;
}
.fin-textbtn:hover { opacity: .75; }
.fin-btn-icon { font-size: 18px; }
.fin-chip {
  display: inline-flex; align-items: center; gap: 8px;
  border-radius: 9999px; padding: 4px 14px; white-space: nowrap;
}
.fin-chip--green { background: rgba(5,150,105,0.10); border: 1px solid rgba(5,150,105,0.20); }
.fin-chip--indigo { background: rgba(79,70,229,0.10); border: 1px solid rgba(79,70,229,0.20); border-radius: 6px; padding: 4px 10px; }
.fin-chip--purple { background: #7e22ce; border-radius: 6px; padding: 5px 12px; box-shadow: 0 1px 2px rgba(0,0,0,.12); }
.fin-chip-label { font-size: 14px; font-weight: 600; color: #059669; }
.fin-chip--green .fin-chip-value { font-size: 18px; font-weight: 700; color: #059669; letter-spacing: -0.01em; }
.fin-chip--indigo .fin-chip-value { font-size: 13px; font-weight: 700; color: #4f46e5; }
.fin-chip--purple .fin-chip-value { font-size: 13px; font-weight: 700; color: #ffffff; }
.fin-split { display: grid; grid-template-columns: 1fr; }
@media (min-width: 960px) { .fin-split { grid-template-columns: 1fr 1fr; } }
.fin-col { display: flex; flex-direction: column; padding: 24px; }
.fin-col--divide { border-top: 1px solid #e2e8f0; }
@media (min-width: 960px) { .fin-col--divide { border-top: none; border-left: 1px solid #e2e8f0; } }
.fin-subtitle { font-size: 13px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; margin: 0 0 12px 0; }
.fin-tablewrap { overflow-x: auto; }
.fin-table { width: 100%; border-collapse: collapse; text-align: left; }
.fin-table th {
  padding: 10px 12px; font-size: 12px; font-weight: 600; letter-spacing: 0.05em;
  text-transform: uppercase; color: #45464d; background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0; white-space: nowrap;
}
.fin-table--wide th, .fin-table--wide td { padding-left: 24px; padding-right: 24px; }
.fin-scroll { max-height: 320px; overflow-y: auto; }
.fin-table--compact th { padding: 6px 10px; }
.fin-table--compact td { padding: 3px 10px; font-size: 13px; }
.fin-table--compact >>> .v-text-field { margin-top: 0; padding-top: 0; font-size: 13px; }
.fin-table--compact >>> .v-text-field > .v-input__control > .v-input__slot { margin-bottom: 0; }
.fin-table--compact >>> .v-input__control { min-height: 30px; }
.fin-table td {
  padding: 12px; font-size: 14px; color: #0f172a; border-bottom: 1px solid #e2e8f0; vertical-align: middle;
}
.fin-table tbody tr:hover { background: rgba(241,245,249,0.6); }
.fin-table .ta-r { text-align: right; }
.fin-table .ta-c { text-align: center; }
.fin-table .fw-500 { font-weight: 500; }
.fin-table .fw-600 { font-weight: 600; }
.fin-table .fw-700 { font-weight: 700; }
.fin-table .muted { color: #45464d; }
.fin-empty { text-align: center; color: #94a3b8; font-size: 13px; padding: 16px; }
.fin-foot { margin-top: auto; padding-top: 16px; text-align: right; }
.fin-foot-label { font-size: 14px; opacity: 0.8; margin-right: 8px; }
.fin-foot-value { font-size: 20px; font-weight: 700; }
.fin-linkbtn {
  display: inline-flex; align-items: center; gap: 6px; background: none; border: none;
  cursor: pointer; font-size: 13px; font-weight: 500; padding: 0; transition: opacity .15s;
}
.fin-linkbtn:hover { opacity: .75; }
.fin-row-clickable { cursor: pointer; }
.fin-expand-icon { font-size: 18px; color: #7e22ce; vertical-align: middle; }
.fin-pill { display: inline-block; font-size: 11px; font-weight: 600; color: #fff; border-radius: 9999px; padding: 2px 10px; }
.fin-pill--green { background: #16a34a; }
.fin-pill--purple { background: #9333ea; }
.fin-pill--amber { background: #d97706; }
.fin-pill--grey { background: #64748b; }
.fin-detail-row > td { background: #faf5ff; padding: 12px 12px 16px; }
.fin-detail-row--amber > td { background: #fffbeb; }
.fin-detail-title { font-size: 12px; font-weight: 600; color: #7e22ce; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 8px; }
.fin-subtable { width: 100%; border-collapse: collapse; background: #fff; border: 1px solid #e9d5ff; border-radius: 6px; }
.fin-subtable th { padding: 6px 12px; font-size: 11px; font-weight: 600; text-transform: uppercase; color: #7e22ce; background: #f3e8ff; border-bottom: 1px solid #e9d5ff; }
.fin-subtable--amber { border-color: #fde68a; }
.fin-subtable--amber th { color: #92400e; background: #fef3c7; border-bottom-color: #fde68a; }
.fin-pure-note {
  display: flex; align-items: center; gap: 6px;
  background: #eff6ff; border: 1px solid #bfdbfe; color: #1e40af;
  border-radius: 6px; padding: 6px 10px; font-size: 13px; margin-bottom: 6px;
}
.fin-pure-note--err { background: #fef2f2; border-color: #fecaca; color: #b91c1c; }
.fin-subtable td { padding: 6px 12px; font-size: 13px; border-bottom: 1px solid #f1eafe; }
.fin-subtable .ta-r { text-align: right; }
.fin-subtable .ta-c { text-align: center; }
.fin-subtable .fw-600 { font-weight: 600; }
.fin-modal-head {
  display: flex; align-items: center; gap: 10px;
  padding: 14px 20px; border-bottom: 1px solid #e2e8f0;
}
.fin-modal-head .fin-title { font-size: 18px; }
.fin-modal-head--amber { background: #fef3c7; border-bottom-color: #fde68a; }
.fin-modal-head--green { background: #d1fae5; border-bottom-color: #a7f3d0; }
.fin-modal-head--indigo { background: #e0e7ff; border-bottom-color: #c7d2fe; }
.fin-modal-head--grey { background: #f1f5f9; border-bottom-color: #e2e8f0; }
.fin-modal-head--teal { background: #ccfbf1; border-bottom-color: #99f6e4; }
.fin-modal-head--purple { background: #f3e8ff; border-bottom-color: #e9d5ff; }
.fin-modal-head .fin-modal-sub { font-size: 12px; font-weight: 500; opacity: .75; margin-left: 4px; }
.fin-modal-close {
  margin-left: auto; background: none; border: none; cursor: pointer;
  display: inline-flex; align-items: center; opacity: .7;
}
.fin-modal-close:hover { opacity: 1; }
.fin-modal-chip {
  margin-left: auto; display: inline-flex; align-items: center;
  background: rgba(15,23,42,0.06); border-radius: 6px; padding: 4px 10px;
  font-size: 13px; font-weight: 700;
}

.recon-card >>> .v-toolbar__content {
  padding-left: 16px;
  padding-right: 12px;
}
.recon-table >>> th {
  height: 34px !important;
  padding: 0 12px !important;
  font-size: 11.5px !important;
  font-weight: 600;
  color: #607d8b;
  background: #fafbfc;
}
.recon-table >>> td {
  height: 38px !important;
  padding: 0 12px !important;
  font-size: 13px !important;
}
.recon-table >>> tbody tr:hover {
  background: #f5f7fa;
}
.recon-table >>> .v-btn {
  margin: 0;
}

.ealtin-order-control-table >>> .v-datatable__wrapper,
.ealtin-order-control-table >>> .v-data-table__wrapper,
.ealtin-order-control-table >>> .v-table__overflow {
  overflow-x: auto;
}
.ealtin-order-control-table >>> table {
  min-width: 2200px;
}
.altindafirsat-order-control-table >>> .v-datatable__wrapper,
.altindafirsat-order-control-table >>> .v-data-table__wrapper,
.altindafirsat-order-control-table >>> .v-table__overflow {
  overflow-x: auto;
}
.altindafirsat-order-control-table >>> table {
  min-width: 3000px;
}
.text-no-wrap {
  white-space: nowrap;
}
@keyframes duplicate-flash {
  0% { background-color: #fff3e0; }
  30% { background-color: #ffb74d; }
  100% { background-color: transparent; }
}
.duplicate-flash {
  animation: duplicate-flash 1.8s ease-out;
}
</style>
